/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from 'clsx';
import { useParams, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Image, Row, Space, Modal } from "antd";
import {
    Switch, FormControl, RadioGroup, Radio, FormControlLabel, Button, InputLabel, TextField, Box, Table, TableHead, TableContainer,
    InputAdornment, Tooltip, Tab, IconButton, Typography, TableCell, TableRow, Checkbox
} from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import DateIcon from "../../../../Shared/components/Icons/Date";
import { deleteRequest } from '../../../../../helpers/axiosClient';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import usePrevious from "../../../../Shared/components/Previous";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import gstActions from "../../../../Admin/Setup/redux/actions";
import addressActions from "../../../../Admin/Address/redux/actions";
import { toast } from 'react-toastify';
import { emptyValidation, customEmailValidation, customNumberValidationQuantity, customNumberValidation } from "../../../../../helpers/validation";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import {
    capitalizeFirstLetter, checkBillProductView, currencyFormat, getColumnWidth, checkCRUDViewPermission, checkCRUDPermission, idNamingConversion, gstCalculation, includeGstSettings,
    checkComponentPermission, scrollToError, storageSetItem, storageGetItem, downloadTitle, getBusinessId
} from "../../../../../helpers/utilities";
import PurchaseInvoiceModal from "../../../../Shared/components/PurchaseInvoiceModal";
import moment from 'moment';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import productActions from "../../../../Product/Product/redux/actions";
import productSetupActions from "../../../../Product/Setup/redux/actions";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import CloseIcon from "../../../../Shared/components/Icons/CloseIcon";
import InfoMark from "../../../../../assets/images/icon_actions/infoMark.svg";
import { templateType, billLineHead } from '../../../../../config/constant';
import dayjs from 'dayjs';
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import businessActions from "../../../../Admin/Home/redux/actions";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";
import SupplierProducts from "./SupplierProducts";
import { getRequest } from '../../../../../helpers/axiosClient';


// Cache of details-array -> Map(id -> object) so customObject() is O(1) instead of
// re-scanning the whole list on every render for each of the ~24 dropdowns. Keyed by the
// array reference (WeakMap), so a new Redux payload naturally invalidates the entry.
const objectIdCache = new WeakMap();
const EMPTY_RESULT = Object.freeze([]);

// Static dropdown heads hoisted out so they are not re-allocated on every render (a fresh
// array literal would defeat React.memo on AutoCompleteComponent).
const SUPPLIER_HEADS = [
    { 'key': 'name', 'name': 'Supplier Name' },
    { 'key': 'mobile', 'name': 'Phone Number' },
    { 'key': 'serialNo', 'name': 'Supplier ID' }
];

const PRODUCT_HEADS_NAME = [
    { key: 'productName', name: 'Product Name' },
    { key: 'code', name: 'Product Code' },
    { key: 'productId', name: 'Product ID' }
];

const PRODUCT_HEADS_DESC = [
    { key: 'description', name: 'Product Name' },
    { key: 'code', name: 'Product Code' },
    { key: 'productId', name: 'Product ID' }
];

// Shared single-column heads.
const HEADS_NAME = [{ 'key': 'name', 'name': 'Name' }];
const HEADS_CODE = [{ 'key': 'code', 'name': 'Code' }];
const HEADS_LABEL = [{ 'key': 'label', 'name': 'Name' }];

// Multi-column heads, one per dropdown.
const MOP_HEADS = [{ 'key': 'method', 'name': 'Method' }, { 'key': 'description', 'name': 'Description' }];
const CURRENCY_HEADS = [{ 'key': 'name', 'name': 'Currency Name' }, { 'key': 'shortName', 'name': 'Currency Short Form' }];
const STATE_HEADS = [{ 'key': 'name', 'name': 'State Name' }, { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }];
const COUNTRY_HEADS = [{ 'key': 'name', 'name': 'Country Name' }];
const PINCODE_HEADS = [{ 'key': 'code', 'name': 'Pincode' }, { 'key': 'city', 'name': 'City', 'relation': 'name' }];
const CITY_HEADS = [{ 'key': 'name', 'name': 'Name' }, { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }];
const AREA_HEADS = [
    { 'key': 'name', 'name': 'Area Name' },
    { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
    { 'key': 'city', 'name': 'City', 'relation': 'name' },
    { 'key': 'state', 'name': 'State', 'relation': 'shortName' }
];
const PARTY_GST_HEADS = [{ 'key': 'code', 'name': 'Party GST Code' }, { 'key': 'description', 'name': 'Description' }];
const UNIT_HEADS = [{ 'key': 'name', 'name': 'Unit' }, { 'key': 'description', 'name': 'Description' }];
const LOCATION_HEADS = [{ 'key': 'name', 'name': 'Location Name' }];
const PRODUCT_GST_HEADS = [{ 'key': 'code', 'name': 'Product GST Code' }, { 'key': 'percentage', 'name': 'Percentage', 'prefix': '%' }];
const HSN_HEADS = [{ 'key': 'hsnCode', 'name': 'HSN Code' }, { 'key': 'description', 'name': 'Description' }];

// Static option list for the Round Off dropdown.
const ROUNDOFF_OPTIONS = [{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }];

// Static (JSX-free) name labels, hoisted so they are not re-allocated every render.
const NAME_ROUND_OFF = ["Round Off"];
const NAME_CASH_DISCOUNT = ["Cash Discount"];
const NAME_TAX_CODE = ["Tax Code"];
const NAME_TCS = ["TCS"];
const NAME_MOP = ["Method of Payment (MOP)"];
const NAME_COUNTRY = ["Country"];
const NAME_CITY = ["Dist/City/Town"];
const NAME_AREA = ["Area"];
const NAME_PARTY_GST = ["Party GST Code "];
const NAME_LOCATION = ["Location"];
const NAME_PRODUCT_GST = ["Product GST Code"];
const NAME_HSN = ["HSN Code"];

// Returns a function whose identity never changes but which always invokes the latest
// closure. Passing this to a memoized child avoids forcing a re-render, while never
// calling a stale version of the handler.
const useStableCallback = (fn) => {
    const fnRef = useRef(fn);
    fnRef.current = fn;
    return useRef((...args) => fnRef.current(...args)).current;
};

const PurchaseSelfBillsEdit = (props) => {
    const [open, setOpen] = useState(false);
    const { businessDetails, parameterDetails } = useSelector(state => state.homeReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { areaDetails, pincodeDetails, stateDetails, countryDetails, cityDetails } = useSelector(state => state.addressReducer);
    const { partyGstdetails, productGstdetails, currencyDetails, mopDetails, hsnDetails, otherTaxesdetails, cashDiscountDetails, taxCodedetails } = useSelector(state => state.adminSetupReducer);
    const { locationDetails } = useSelector(state => state.productSetupReducer);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);
    const { myProductdetails, productPrices } = useSelector(state => state.productProductReducer);
    const { readDetails, readLoader, editDetails, editData, editError, editLoader, readError } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    const [supplierId, setSupplierId] = useState('');
    const [lineSalesValue, setLineSalesValue] = useState('');
    const [supplierDetail, setSupplierDetail] = useState('');
    const [inAppStatus, setInAppStatus] = useState("");
    const [inAppTransition, setInAppTransition] = useState(false);
    const [status, setStatus] = useState('Created');
    const [viewStatus, setViewStatus] = useState('Created');
    const [showNameDesc, setShowNameDesc] = useState(checkBillProductView());
    const [value, setValue] = useState('lineView');
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [transactionDate, setTransactionDate] = useState(new Date());
    const [dueDate, setDueDate] = useState(new Date());
    const [excisesAmount, setExcisesAmount] = useState('');
    const [assessableValue, setAssessableValue] = useState('');
    const [taxCodeId, setTaxCodeId] = useState('');
    const [tcsNameId, setTcsNameId] = useState('');
    const [tax, setTax] = useState('');
    const [tcs, setTcs] = useState('');
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [areaId, setAreaId] = useState('');
    const [pincodeId, setPincodeId] = useState('');
    const [stateId, setStateId] = useState('');
    const [cityId, setCityId] = useState('');
    const [countryId, setCountryId] = useState('');
    const [lineNumber, setLineNumber] = useState(1);

    const [gstCodeId, setGstCodeId] = useState('');
    const [includeGst, setIncludeGst] = useState(false);
    const [supplierRefNum, setSupplierRefNum] = useState('');
    const [units, setUnits] = useState([]);
    const [roundOffAmount, setRoundOffAmount] = useState(0);
    const [roundOffMethod, setRoundOffMethod] = useState('');
    const [total, setTotal] = useState(parseFloat(0.00));
    const [totalInvoice, setTotalInvoice] = useState(parseFloat(0.00));
    const [gstAmount, setGstAmount] = useState(parseFloat(0.00));
    const [totalDiscount, setTotalDiscount] = useState(parseFloat(0.00));
    const [netAmount, setNetAmount] = useState(parseFloat(0.00));
    const [lines, setLines] = useState([]);
    const [priceIncludesTax, setPriceIncludesTax] = useState(false);
    const [viewVisible, setViewVisible] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const prevReadDetails = usePrevious(readDetails);
    const prevReadError = usePrevious(readError);
    const [lineEdit, setLineEdit] = useState(false);
    const [serialNumber, setSerialNumber] = useState('');
    const [unitPriceList, setUnitPriceList] = useState(false);
    const [unitPriceFocusList, setUnitPriceFocusList] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [comments, setComments] = useState('');
    const [dispatchDetails, setDispatchDetails] = useState('');
    const [cashDiscountId, setCashDiscountId] = useState('');
    const [cashDiscountAmount, setCashDiscountAmount] = useState('');
    const [lineId, setLineId] = useState('');
    const [lineProduct, setLineProduct] = useState('');
    const [lineBatchActivation, setLineBatchActivation] = useState(false);
    const [lineDescription, setLineDescription] = useState('');
    const [lineQuantity, setLineQuantity] = useState('');
    const [lineUnitId, setLineUnitId] = useState('');
    const [linePrice, setLinePrice] = useState('');
    const [lineAmount, setLineAmount] = useState('');
    const [lineDiscountAmount, setLineDiscountAmount] = useState('');
    const [lineDiscountPercentage, setLineDiscountPercentage] = useState('');
    const [lineIncludeGst, setLineIncludeGst] = useState(false);
    const [lineLocationId, setLineLocationId] = useState('');
    const [lineProductGstId, setLineProductGstId] = useState('');
    const [lineDiscountPercAmount, setLineDiscountPercAmount] = useState(0);
    const [lineDiscountCalcAmount, setLineDiscountCalcAmount] = useState(0);
    const [lineHsnId, setLineHsnId] = useState('');
    const [lineGstAmount, setLineGstAmount] = useState('');
    const [lineCgst, setLineCgst] = useState('');
    const [lineSgst, setLineSgst] = useState('');
    const [lineIgst, setLineIgst] = useState('');
    const [lineMrp, setLineMrp] = useState('');
    const [lineStock, setLineStock] = useState({});
    const [stockLoading, setStockLoading] = useState(false);
    // const [linePriceIncludesTax, setLinePriceIncludesTax] = useState(false);
    const [lineUniversalProductId, setLineUniversalProductId] = useState('');
    // const [lineUseMrp, setLineUseMrp] = useState(false);
    const [primaryTitle, setPrimaryTitle] = useState('Add');
    // const [addMore, setAddMore] = useState(false);
    const [supplierSerialNumber, setSupplierSerialNumber] = useState('');
    const [lineCgstAmount, setLineCgstAmount] = useState('');
    const [lineSgstAmount, setLineSgstAmount] = useState('');
    const [lineIgstAmount, setLineIgstAmount] = useState('');
    const [includeDisabled, setIncludeDisabled] = useState(false);

    const [lineDiscountType, setLineDiscountType] = useState(parameterDetails?.discountRate ? 'perUnit' : 'fixed');
    const [lineDiscountRate, setLineDiscountRate] = useState('');

    const [lineExcisesApplicable, setLineExcisesApplicable] = useState(false);
    const [lineExcisesType, setLineExcisesType] = useState('perUnit');
    const [lineSplExcisesType, setLineSplExcisesType] = useState('perUnit');
    const [lineExcisesRate, setLineExcisesRate] = useState('');
    const [lineSplExcisesRate, setLineSplExcisesRate] = useState('');
    const [lineExcisesAmount, setLineExcisesAmount] = useState('');
    const [lineSplExcisesAmount, setLineSplExcisesAmount] = useState('');
    const [lineAddExcisesAmount, setLineAddExcisesAmount] = useState('');
    const [lineExcisesTotal, setLineExcisesTotal] = useState('');
    const [lineTotalCostPrice, setLineTotalCostPrice] = useState('');

    const [notificationLineCgstAmount, setNotificationLineCgstAmount] = useState('');
    const [notificationLineSgstAmount, setNotificationLineSgstAmount] = useState('');
    const [notificationLineIgstAmount, setNotificationLineIgstAmount] = useState('');
    const [notificationLineGstAmount, setNotificationLineGstAmount] = useState('');

    const [errorLineDescription, setErrorLineDescription] = useState(false);
    const [errorLineUnitId, setErrorLineUnitId] = useState(false);
    const [errorLinePrice, setErrorLinePrice] = useState(false);
    const [errorRoundOffAmount, setErrorRoundOffAmount] = useState('');
    const [errorLineQuantity, setErrorLineQuantity] = useState(false);
    // const [errorLineAmount, setErrorLineAmount] = useState(false);
    const [errorLineProductGst, setErrorLineProductGst] = useState(false);
    const [errorLineHsn, setErrorLineHsn] = useState(false);
    const [errorSupplierRefNum, setErrorSupplierRefNum] = useState(false);
    const [errorDueDate, setErrorDueDate] = useState(false);
    //const [details, setDetails] = useState("read");
    const [commonError, setCommonError] = useState('');
    const [errorBatchQuantity, setErrorBatchQuantity] = useState(false);
    const { history } = props;
    const { billId } = useParams();
    const decryptedId = AESDecrypt(billId);
    const [mopId, setMopId] = useState('');
    const [currencyId, setCurrencyId] = useState('');
    const [errorSupplierId, setErrorSupplierId] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [errorCurrency, setErrorCurrency] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorGstCode, setErrorGstCode] = useState(false);
    const [errorState, setErrorState] = useState('');
    const [errorPincode, setErrorPincode] = useState(false);
    const [showDetails, setShowDetails] = useState(true);
    const [preview, setPreview] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [billFormat, setBillFormat] = useState('');
    const [debitNote, setDebitNote] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const childRef = useRef('');
    const [dateChange, setDateChange] = useState('');
    const [productsVisible, setProductsVisible] = useState(false);
    const [batch, setBatch] = useState([]);
    const [viewBatch, setViewBatch] = useState(false);
    const [batchOverride, setBatchOverride] = useState(false);
    const [selectedBatchId, setSelectedBatchId] = useState([]);
    const [autoMark, setAutoMark] = useState(false);
    const [debitBatch, setDebitBatch] = useState(false);

    const handleOpen = () => {
        setLineEdit(true);
        if (includeGst && gstCodeId === '') {
            toast.dismiss();
            toast.warning('Please Select Party GST code');
        } else {
            setVisible(true);
            emptyLineState();
            emptyLineStateInput();
            setLineNumber(parseInt(lines.length + 1));
            setPrimaryTitle('Add');
            dispatch({ type: productActions.CLEAR_PRICE_START });
            hsnApi(); setUnits(unitMesurementdetails);
            productApi(); locationApi(); setViewBatch(false); setBatch([]); setBatchOverride(false); setSelectedBatchId([]); setDebitBatch(false);
        }
    };

    const handleClose = () => {
        setVisible(false);
        emptyLineState();
        emptyLineStateInput();
    }

    const handleViewClose = () => {
        setViewVisible(false);
    }

    const emptyLineState = () => {
        setErrorLineDescription(false);
        setErrorLineUnitId(false);
        setErrorLinePrice(false);
        setErrorLineQuantity(false);
        // setErrorLineAmount(false);
        setErrorBatchQuantity(false);
        setErrorLineProductGst(false);
        setErrorLineHsn(false);
    }


    const emptyLineStateInput = () => {
        setLineId('');
        setLineProduct('');
        setLineBatchActivation(false);
        setLineLocationId('');
        setLineDescription('');
        setLineQuantity('');
        setLineUnitId('');
        setLineStock({});
        setLinePrice('');
        setLineSalesValue('');
        setLineDiscountType(parameterDetails?.discountRate ? 'perUnit' : 'fixed');
        setLineDiscountRate('');
        setLineAmount('');
        setLineDiscountAmount('');
        setLineDiscountPercAmount('');
        setLineDiscountCalcAmount('');
        setLineDiscountPercentage('');
        setLineProductGstId('');
        setLineHsnId('');
        setLineGstAmount('');
        setLineCgst('');
        setLineSgst('');
        setLineIgst('');
        setLineCgstAmount('');
        setLineSgstAmount('');
        setLineIgstAmount('');
        setLineIncludeGst(includeGst);
        setLineMrp('');
        //  setLinePriceIncludesTax(false);
        setLineUniversalProductId('');
        setBatchOverride(false);
        //  setLineUseMrp(false);
    }

    useEffect(() => {
        if (billId === undefined || decryptedId === 0) {
            history.push("/purchase/purchase-management/self-bill");
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('Supply Self Bill', 'edit', history, 'Purchase')) {
            loadTasks();
        }
        return () => {
            dispatch({ type: productActions.CLEAR_PRICE_START });
            dispatch({ type: addressActions.CLEAR_ADDRESS_DETAILS_START });
            dispatch({ type: actions.CLEAR_PURCHASE_MANAGEMENT_DETAILS_START });
        };
    }, [billId, roleManagement]);

    useEffect(() => {
        if (locationDetails && locationDetails?.length > 0 && lineLocationId === '') {
            let a = locationDetails?.filter(el => el.default);
            if (a?.length > 0) {
                setLineLocationId(a[0]?.id);
            } else {
                setLineLocationId(locationDetails[0]?.id);
            }
        }
    }, [locationDetails]);


    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 76) {
            e.preventDefault();
            handleOpen();
        } else if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            if (visible) {
                handleLineSubmit(e);
            } else if (confirm) {
                handleCommonSubmit('CONFIRMED');
            } else {
                handleSubmit(e);
            }
        } else if (e.altKey && e.keyCode === 79) {
            e.preventDefault();
            if (lines && lines?.length === 0) {
                toast.dismiss();
                toast.error('If you want confirm, please add (add lines) and then confirm it...');
            } else {
                handleConfirmSubmit()
            }
        }
    };

    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        handleSetProductPrice(lineUnitId, lineEdit);
    }, [productPrices]);

    const handleSetProductPrice = (lineUnitId = '', lineEdit) => {
        if (productPrices && productPrices !== '') {
            let d = customObject(myProductdetails, lineProduct);
            if (productPrices?.priceagreement && Object.keys(productPrices?.priceagreement).length > 0 &&
                productPrices?.priceagreement[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                let result = productPrices?.priceagreement[customObject(unitMesurementdetails, lineUnitId)?.name][0];
                if (!lineEdit) {
                    setLinePrice(result?.price || d?.latestPurchasePrice || '');
                    setLineMrp(result?.mrp || d?.mrp || '');
                    setLineSplExcisesRate(result?.specialExcisesDuty || '');
                }
                setUnitPriceList(true);
                // setLineUseMrp(result?.isMrp);
            } else {
                if (!lineEdit) {
                    if (productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
                        productPrices?.lastprice[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                        let result = productPrices?.lastprice[customObject(unitMesurementdetails, lineUnitId)?.name];
                        setLinePrice(result?.price || d?.latestPurchasePrice || '');
                        setLineMrp(result?.mrp || d?.mrp || '');
                        setUnitPriceList(false);
                    } else {
                        let d = customObject(myProductdetails, lineProduct);
                        if (d) {
                            // setLineUseMrp(d?.useMrp);
                            setLinePrice(d?.latestPurchasePrice || '');
                            setLineMrp(d?.mrp || '');
                        }
                    }
                }
            }
            if (!lineEdit) {
                if (productPrices?.lastdiscount && Object.keys(productPrices?.lastdiscount).length > 0 && productPrices?.lastdiscount[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                    let result = productPrices?.lastdiscount[customObject(unitMesurementdetails, lineUnitId)?.name];
                    if (!parameterDetails?.discountRate && result?.amount) {
                        setLineDiscountAmount(result?.amount || '');
                    }
                    if (parameterDetails?.discountRate && result?.rate) {
                        setLineDiscountRate(result?.rate || '');
                    }
                    if (result?.percent) {
                        setLineDiscountPercentage(result?.percent || '');
                    }
                } else {
                    setLineDiscountPercentage('');
                }
            }
        } else {
            if (!lineEdit) {
                let d = customObject(myProductdetails, lineProduct);
                if (d) {
                    // setLineUseMrp(d?.useMrp);
                    setLinePrice(d?.latestPurchasePrice || '');
                    setLineMrp(d?.mrp || '');
                }
                setLineDiscountPercentage('');
            }
        }
    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'PURCHASE' } }] }] };
        let or = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const hsnApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: filter,
                order: 'hsnCode asc',
                limit: 500,
                skip: 0
            },
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({ type: businessActions.BUSINESS_DETAILS_START });
        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.PARTYGST_DETAILS_START, url: 'partygst', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.TAXCODE_DETAILS_START, url: 'taxcode', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.OTHERTAXES_DETAILS_START, url: 'othertaxes', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.CASHDISCOUNT_DETAILS_START, url: 'cashdiscount', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
        // dispatch({
        //     type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products', filter: {
        //         where: { "and": [{ status: 'ACTIVE' }] },
        //         order: 'id  desc'
        //     }
        // });
        //hsnApi('');
        dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "purchaseSelfBill" });
        // dispatch({
        //     type: actions.SUPPLIER_DETAILS_START, url: 'supplierProfile', filter: {
        //         order: 'id desc'
        //     }
        // });
    });

    const emptyState = () => {
        setErrorSupplierId(false);
        setErrorMobile(false);
        setErrorEmail(false);
        setErrorCurrency(false);
        setErrorGstCode(false);
        setErrorState(false);
        setErrorPincode(false);
        setErrorSupplierRefNum(false);
        setCommonError(false); setErrorDueDate(false);
        setErrorRoundOffAmount(false);
    }

    const handleConfirmSubmit = () => {
        childRef?.current?.handleAdjustHeight();
        let emailCheck = true;
        let incudeGstCode = true;
        let emptySupplier = emptyValidation('Supplier Name', supplierId, 'dropDown');
        let emptyMobile = emptyValidation('Phone Number', mobile);
        let emptyEmail = customEmailValidation('Email', email);
        if (email !== null && email !== '' && !emptyEmail.isValid) {
            emailCheck = false;
        }
        let emptyGstCode = emptyValidation('Party GST Code', gstCodeId, 'dropDown');
        let emptyStateCheck = emptyValidation('State', stateId, 'dropDown');
        if ((includeGst && !emptyGstCode.isValid) || (includeGst && !emptyStateCheck.isValid)) {
            incudeGstCode = false
        }
        let emptyPincode = emptyValidation('Pincode', pincodeId, 'dropDown');
        let emptySupplierRefNum = { isValid: true, errors: '' };
        if (!inAppTransition) {
            emptySupplierRefNum = emptyValidation('Supplier invoice number', supplierRefNum);
        }
        let emptyCurrency = emptyValidation('Currency', currencyId, 'dropDown');

        let stateCheck = true;
        if (supplierDetail?.taxType?.taxCode === 'COMP' && businessDetails?.stateId !== stateId) {
            stateCheck = false;
        }
        let dueDateCheck = moment(moment(dueDate).format('YYYY-MM-DD')).isSameOrAfter(moment(invoiceDate).format('YYYY-MM-DD'));
        let roundOff = true;
        if (roundOffMethod && roundOffAmount === '') {
            roundOff = false;
        }
        emptyState();
        if (emptySupplier.isValid && dueDateCheck && stateCheck && emptyCurrency.isValid && emptyStateCheck.isValid &&
            emptyMobile.isValid && emailCheck && incudeGstCode && emptyPincode.isValid && emptySupplierRefNum.isValid && roundOff) {
            setConfirm(true);
        } else {
            setConfirm(false);
            if (emptySupplier.errors) {
                setErrorSupplierId(emptySupplier.errors);
            }
            if (emptyCurrency.errors) {
                setErrorCurrency(emptyCurrency.errors);
            }
            if (emptyMobile.errors) {
                setErrorMobile(emptyMobile.errors);
            }
            if (!dueDateCheck) {
                setErrorDueDate('Due Date should greater or equal to invoice date');
            }
            if (!emailCheck) {
                setErrorEmail(emptyEmail.errors);
            }
            if (includeGst && emptyGstCode.errors) {
                setErrorGstCode(emptyGstCode.errors);
            }
            //if (includeGst && emptyStateCheck.errors) {
            if (emptyStateCheck.errors) {
                setErrorState(emptyStateCheck.errors);
            }

            if (!stateCheck) {
                toast.dismiss();
                toast.error('Please note you are in GST-Composite scheme and Supply Self Bill cannot be generated due to Supplier billing address in different state.');
            }
            if (!roundOff) {
                setErrorRoundOffAmount('Please enter a valid value in Round Off');
            }
            if (emptyPincode.errors) {
                setErrorPincode(emptyPincode.errors);
            }
            if (emptySupplierRefNum.errors) {
                setErrorSupplierRefNum(emptySupplierRefNum.errors);
            }
            let v = 'headerView';
            if (emptySupplier?.errors || emptyMobile?.errors || emptySupplierRefNum?.errors || !roundOff) {
                v = 'lineView';
            }
            handleChange(v);
            scrollToError();
        }
    }

    const handleAllGstCalc = (element) => {
        let a = element;
        if (element.includeGst && element.productGstId) {
            let p = productGstdetails?.filter((el) => { return el.id === element.productGstId });
            let percentage = p[0].percentage;
            let details = {
                percentage: percentage,
                stateId: stateId,
                lineAmount: element.amount,
                priceIncludesTax: priceIncludesTax || false
            };
            // let gstCalc = gstCalculation({ ...businessDetails, stateId: supplierDetail.stateId }, details, supplierDetail);
            let gstCalc = gstCalculation(businessDetails, details, supplierDetail);
            a = {
                ...element,
                igstPercentage: parseFloat(gstCalc?.igst || 0),
                cgstPercentage: parseFloat(gstCalc?.cgst || 0),
                sgstPercentage: parseFloat(gstCalc?.sgst || 0),
                cgst: parseFloat(gstCalc?.cgstAmount || 0),
                sgst: parseFloat(gstCalc?.sgstAmount || 0),
                igst: parseFloat(gstCalc?.igstAmount || 0),
            };
        }

        return a;
    }

    const handleCommonSubmit = (status, callDispatch = true) => {
        childRef?.current?.handleAdjustHeight();
        let emailCheck = true;
        let incudeGstCode = true;
        let emptySupplier = emptyValidation('Supplier Name', supplierId, 'dropDown');
        let emptyMobile = emptyValidation('Phone Number', mobile);
        let emptyEmail = customEmailValidation('Email', email);
        if (email !== null && email !== '' && !emptyEmail.isValid) {
            emailCheck = false;
        }
        let emptyGstCode = emptyValidation('Party GST Code', gstCodeId, 'dropDown');
        let emptyStateCheck = emptyValidation('State', stateId, 'dropDown');
        if ((includeGst && !emptyGstCode.isValid) || (includeGst && !emptyStateCheck.isValid)) {
            incudeGstCode = false
        }
        let emptyPincode = emptyValidation('Pincode', pincodeId, 'dropDown');
        // let emptySupplierRefNum = '';
        // if (inAppTransition) {
        //     emptySupplierRefNum = customAlaphaNumericOptional('Supplier invoice number', supplierRefNum);
        // } else {
        //     emptySupplierRefNum = customAlaphaNumeric('Supplier invoice number', supplierRefNum);
        // }

        let emptySupplierRefNum = { isValid: true, errors: '' };
        if (!inAppTransition) {
            emptySupplierRefNum = emptyValidation('Supplier invoice number', supplierRefNum);
        }
        let emptyCurrency = emptyValidation('Currency', currencyId, 'dropDown');

        let stateCheck = true;
        if (supplierDetail?.taxType?.taxCode === 'COMP' && businessDetails?.stateId !== stateId) {
            stateCheck = false;
        }
        let dueDateCheck = moment(moment(dueDate).format('YYYY-MM-DD')).isSameOrAfter(moment(invoiceDate).format('YYYY-MM-DD'));
        let roundOff = true;
        if (roundOffMethod && roundOffAmount === '') {
            roundOff = false;
        }
        emptyState();
        if (emptySupplier.isValid && dueDateCheck && stateCheck && emptyCurrency.isValid && emptyStateCheck.isValid &&
            emptyMobile.isValid && emailCheck && incudeGstCode && emptyPincode.isValid && emptySupplierRefNum.isValid && roundOff) {
            setStatus(status);
            // lines && lines.length > 0 && lines.map((element, i) => {
            //     delete element.productGst; delete element.product; delete element.productCategory;
            //     delete element.hsn;
            //     delete element.unit;
            //     let mLines = { ...handleAllGstCalc(element) };
            //     lines.splice(i, 1, mLines);
            // });
            let aL = [];
            lines && lines?.length > 0 && lines?.map((element, i) => {
                if (element?.pricePerUnit) {
                    element.pricePerUnit = parseFloat(element?.pricePerUnit);
                }
                element.productGstId = element?.productGstId || undefined;
                element.discountAmount = element?.discountAmount ? parseFloat(element?.discountAmount) : 0;
                element.discountPercent = element?.discountPercent ? parseFloat(element?.discountPercent) : 0;
                return aL.push({ ...handleAllGstCalc(element) })
            });
            let details = {
                name: name,
                // transactionDate: transactionDate,
                // invoiceDate: invoiceDate,
                // dueDate: dueDate,
                invoiceDate: invoiceDate,
                transactionDate: moment(transactionDate).format("YYYY-MM-DDT00:00:00.000+00:00"),
                dueDate: dueDate,
                phone: mobile,
                currencyId: currencyId,
                supplierId: supplierId,
                selfBillItems: aL,
                billStatus: status,
                countryId: countryId,
                includeGst: includeGst,
                gstAmount: gstAmount,
                billFormat: billFormat,
                serialNo: readDetails?.serialNo,
                comments: comments || '',
                dispatchDetails: dispatchDetails || '', roundOffMethod: roundOffMethod || null, roundOffAmount: parseFloat(roundOffAmount || 0),
                mopId: mopId || null,
                address1: address || '',
                email: email || '',
                partyGstId: gstCodeId || null,
                areaId: areaId || null,
                pincodeId: pincodeId || null,
                stateId: stateId || null,
                cityId: cityId || null, priceIncludesTax: priceIncludesTax || false,
                cashDiscountAmount: cashDiscountAmount || 0,
                cashDiscountId: cashDiscountId || 0,
                taxCodeId: taxCodeId || null,
                tcsNameId: tcsNameId || null,
                tcs: tcs || 0,
                tax: tax || 0
            };

            if (supplierDetail && supplierDetail?.gstin) {
                details["gstin"] = supplierDetail?.gstin;
            }

            if (assessableValue) {
                details["assessableValue"] = assessableValue;
            }

            if (excisesAmount) {
                details["excisesAmount"] = excisesAmount;
            }

            // if (taxCodeId) {
            //     details["taxCodeId"] = taxCodeId;
            // }

            // if (tax) {
            //     details["tax"] = tax;
            // }

            // if (tcs) {
            //     details["tcs"] = tcs;
            // }

            if (inAppTransition) {
                details["inAppTransition"] = inAppTransition;
            } else {
                details["inAppTransition"] = false;
            }

            if (!readDetails?.isViaNotification) {
                details["invoiceAmount"] = total;
            }

            // if (email) {
            //     details["email"] = email;
            // }
            // if (address) {
            //     details["address1"] = address;
            // }
            // if (gstCodeId) {
            //     details["partyGstId"] = gstCodeId;
            // }
            // if (mopId) {
            //     details["mopId"] = mopId;
            // }
            // if (areaId) {
            //     details["areaId"] = areaId;
            // }
            // if (pincodeId) {
            //     details["pincodeId"] = pincodeId;
            // }
            // if (stateId) {
            //     details["stateId"] = stateId;
            // }
            // if (cityId) {
            //     details["cityId"] = cityId;
            // }
            if (!inAppTransition && supplierRefNum) {
                details["supplierRefNum"] = supplierRefNum;
            }

            if (callDispatch) {
                aL && aL.length > 0 && aL.map((element, i) => {
                    delete element.productGst; delete element.product; delete element.productCategory; delete element.batchActivation;
                    delete element.hsn; delete element.stockUnit;
                    delete element.unit; delete element.location;
                    aL.splice(i, 1, element);
                });
                details.selfBillItems = aL;
                dispatch({
                    type: crudActions.EDIT_DETAILS_START,
                    url: 'purchaseSelfBill',
                    title: 'Purchase Self Bill',
                    id: decryptedId,
                    details: details
                });
            } else {
                return details;
            }
        } else {
            setConfirm(false);
            if (emptySupplier.errors) {
                setErrorSupplierId(emptySupplier.errors);
            }
            if (emptyCurrency.errors) {
                setErrorCurrency(emptyCurrency.errors);
            }
            if (emptyMobile.errors) {
                setErrorMobile(emptyMobile.errors);
            }
            if (!dueDateCheck) {
                setErrorDueDate('Due Date should greater or equal to invoice date');
            }
            if (!emailCheck) {
                setErrorEmail(emptyEmail.errors);
            }
            if (includeGst && emptyGstCode.errors) {
                setErrorGstCode(emptyGstCode.errors);
            }
            //if (includeGst && emptyStateCheck.errors) {
            if (emptyStateCheck.errors) {
                setErrorState(emptyStateCheck.errors);
            }

            if (!stateCheck) {
                toast.dismiss();
                toast.error('Please note you are in GST-Composite scheme and Supply Self Bill cannot be generated due to Supplier billing address in different state.');
            }
            if (!roundOff) {
                setErrorRoundOffAmount('Please enter a valid value in Round Off');
            }
            if (emptyPincode.errors) {
                setErrorPincode(emptyPincode.errors);
            }
            if (emptySupplierRefNum.errors) {
                setErrorSupplierRefNum(emptySupplierRefNum.errors);
            }
            let v = 'headerView';
            if (emptySupplier?.errors || emptyMobile?.errors || emptySupplierRefNum?.errors || !roundOff) {
                v = 'lineView';
            }
            handleChange(v);
            scrollToError();
            if (!callDispatch) {
                return false;
            }
        }
    }

    const handleSubmit = (e, status = 'CREATED') => {
        e.preventDefault();
        handleCommonSubmit(status);
    }


    useEffect(() => {
        if (preview && hsnDetails && hsnDetails.length > 0) {
            setDataPreview();
        }
    }, [preview, hsnDetails]);

    const hsnApiArray = (ids = []) => {
        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: { id: { inq: ids } },
                order: 'hsnCode asc',
                limit: 500,
                skip: 0
            },
        });
    }

    const handlePreview = () => {
        let data = handleCommonSubmit('CREATED', false);
        if (data) {
            let hsnIds = [];
            if (data?.selfBillItems && data?.selfBillItems?.length > 0) {
                data?.selfBillItems?.map(function (element, i) {
                    if (element?.hsnId) {
                        hsnIds.push(element?.hsnId);
                    }
                });
            }

            if (hsnIds.length > 0) {
                hsnApiArray(hsnIds);
            } else {
                setDataPreview();
            }
            setPreview(true);
            setOpen(true);
        }
    }

    const setDataPreview = () => {
        let data = handleCommonSubmit('CREATED', false);
        console.log('preview data', data);
        if (data) {
            if (data?.areaId) {
                data['area'] = customObject(areaDetails, data?.areaId);
            }
            if (data?.pincodeId) {
                data['pincode'] = customObject(pincodeDetails, data?.pincodeId);
            }
            if (data?.stateId) {
                data['state'] = customObject(stateDetails, data?.stateId);
            }
            if (data?.cityId) {
                data['city'] = customObject(cityDetails, data?.cityId);
            }
            if (data?.countryId) {
                data['country'] = customObject(countryDetails, data?.countryId);
            }
            if (data?.currencyId) {
                data['currency'] = customObject(currencyDetails, data?.currencyId);
            }
            if (data?.mopId) {
                data['mop'] = customObject(mopDetails, data?.mopId);
            }
            // if (readDetails?.isViaNotification) {
            if (readDetails?.supplier) {
                data['supplier'] = readDetails['supplier'];
            }
            if (readDetails?.isViaNotification && readDetails?.invoiceAmount) {
                data['invoiceAmount'] = readDetails['invoiceAmount'];
            }
            if (readDetails?.isViaNotification && readDetails?.supplierRefNum) {
                data['supplierRefNum'] = readDetails?.supplierRefNum;
            }
            if (readDetails?.supplierId) {
                data['supplierId'] = readDetails['supplierId'];
            }
            if (readDetails?.business) {
                data['business'] = readDetails?.business;
            }
            if (data?.taxCodeId) {
                data['taxCode'] = customObject(taxCodedetails, data?.taxCodeId);
            }
            if (data?.cashDiscountId) {
                data['cashDiscount'] = customObject(cashDiscountDetails, data?.cashDiscountId);
            }
            // }
            if (data?.selfBillItems && data?.selfBillItems?.length > 0) {
                data?.selfBillItems?.map(function (element, i) {
                    element['lineNumber'] = i + 1;
                    if (element?.hsnId) {
                        element['hsn'] = customObject(hsnDetails, element?.hsnId);
                    }
                    if (element?.unitId) {
                        element['unit'] = customObject(unitMesurementdetails, element?.unitId);
                    }
                    if (element?.productGstId) {
                        element['productGst'] = customObject(productGstdetails, element?.productGstId);
                    }
                    let mLines = { ...element };
                    data?.selfBillItems?.splice(i, 1, mLines);
                });
            }
            setPreviewData(data);
        }
    }

    const supplierApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: actions.SUPPLIER_DETAILS_START, url: 'supplierProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            if (readDetails.billStatus !== 'CREATED') {
                toast.error('Bill already confirmed');
                history.push("/purchase/purchase-management/self-bill");
            } else if (readDetails?.supplier?.isHold) {
                toast.error('Please release the Supplier from ON-HOLD to allow for transaction to be processed.');
                history.push("/purchase/purchase-management/self-bill");
            }

            if (readDetails?.stateId) {
                changeStateApi(readDetails?.stateId);
            }

            if (readDetails?.pincodeId) {
                dispatch({
                    type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                        where: { ["and"]: [{ pincodeId: readDetails?.pincodeId }] }
                    }
                });
            }
            supplierApi('', readDetails.supplierId);
            setStatus(readDetails.billStatus);
            setPriceIncludesTax(readDetails?.priceIncludesTax || false);
            setViewStatus(readDetails.billStatus);
            setSerialNumber(readDetails.serialNo);
            setName(readDetails.name);
            setSupplierId(readDetails.supplierId);
            setSupplierDetail(readDetails?.supplier);
            setSupplierSerialNumber(readDetails.supplier.serialNo);
            setTransactionDate(readDetails?.transactionDate ? dayjs(readDetails?.transactionDate).$d : new Date());
            setInvoiceDate(readDetails?.invoiceDate ? dayjs(readDetails?.invoiceDate).$d : new Date());
            setDueDate(readDetails?.dueDate ? dayjs(readDetails?.dueDate).$d : new Date());
            setLines(readDetails.selfBillItems ? readDetails.selfBillItems : []);
            setAreaId(readDetails.areaId);
            setGstCodeId(readDetails.partyGstId && readDetails.partyGstId > 0 ? readDetails.partyGstId : '');
            setPincodeId(readDetails?.pincodeId || '');
            setCityId(readDetails?.cityId || '');
            setStateId(readDetails?.stateId || '');
            setCountryId(readDetails?.countryId || '');
            setCurrencyId(readDetails?.currencyId || '');
            setMopId(readDetails?.mopId || '');
            setRoundOffAmount(readDetails?.roundOffAmount || 0);
            setRoundOffMethod(readDetails?.roundOffMethod || '');
            setAddress(readDetails?.address1 || '');
            setEmail(readDetails?.email || '');
            setMobile(readDetails?.phone || '');
            handleIncludeGst(readDetails.includeGst, false);
            setSupplierRefNum(readDetails.supplierRefNum)
            setInAppStatus(readDetails?.supplier?.inAppStatus || '');
            setInAppTransition(readDetails.inAppTransition || false);
            setComments(readDetails?.comments || '');
            setDispatchDetails(readDetails?.dispatchDetails || '');
            //  calculateGrandTotal(readDetails?.selfBillItems || []);
            setTaxCodeId(readDetails?.taxCodeId || null);
            setTcsNameId(readDetails?.tcsNameId || null);
            setCashDiscountId(readDetails?.cashDiscountId || null);
            if (readDetails?.invoiceAmount < 0) {
                setDebitNote(true);
            }
            if (readDetails?.supplier?.taxType?.taxCode === 'COMP') {
                setBillFormat('billSupply');
            } else {
                setBillFormat(readDetails?.billFormat || 'format1');
            }
            let gstSetting = includeGstSettings(readDetails?.supplier, readDetails?.business);
            setIncludeDisabled(gstSetting.includeDisabled);

            let gst = readDetails.selfBillItems ? readDetails?.selfBillItems?.reduce((a, v) => a = a + v.gstAmount, 0) : 0;
            if (gst > 0) {
                setIncludeGst(true);
                setLineIncludeGst(true);
            }
            setShowDetails(false);
            if (storageGetItem('purchaseView')) {
                handleChange(storageGetItem('purchaseView'));
            }
        } else if (prevReadError !== undefined && readError && prevReadError !== readError) {

        }
    }, [readDetails, readError]);


    const handleIncludeGst = (value, onLoad = true) => {
        if (onLoad) {
            setModalVisible(true);
        } else {
            handleLineGST(value);
        }
    }

    const handleLineGST = (value) => {
        setIncludeGst(value);
        setLineIncludeGst(value);
        if (!value) {
            lines && lines.length > 0 && lines.map(function (element, i) {
                let mLines = {
                    ...element,
                    includeGst: false,
                    igstPercentage: 0,
                    cgstPercentage: 0,
                    sgstPercentage: 0,
                    cgst: 0,
                    sgst: 0,
                    igst: 0,
                    gstAmount: 0,
                };
                lines.splice(i, 1, mLines);
            });
        } else {
            lines && lines.length > 0 && lines.map(function (element, i) {
                let party = partyGstdetails && partyGstdetails.filter(function (el) { return el.id === gstCodeId });
                if (party.length !== 0) {
                    if (element.productGstId) {
                        if (element.productGstId) {
                            let p = party[0].productGsts && party[0].productGsts.filter(function (el) { return el.id === element.productGstId });
                            if (p.length !== 0) {
                                let percentage = p[0].percentage;
                                let details = {
                                    percentage: percentage,
                                    stateId: stateId,
                                    lineAmount: element.amount,
                                    priceIncludesTax: priceIncludesTax || false
                                };
                                let gstCalc = gstCalculation(businessDetails, details, supplierDetail);
                                let mLines = {
                                    ...element,
                                    includeGst: true,
                                    igstPercentage: parseFloat(gstCalc?.igst || 0),
                                    cgstPercentage: parseFloat(gstCalc?.cgst || 0),
                                    sgstPercentage: parseFloat(gstCalc?.sgst || 0),
                                    cgst: parseFloat(gstCalc?.cgstAmount || 0),
                                    sgst: parseFloat(gstCalc?.sgstAmount || 0),
                                    igst: parseFloat(gstCalc?.igstAmount || 0),
                                    gstAmount: parseFloat(gstCalc.gAmount || 0),
                                };

                                lines.splice(i, 1, mLines);
                            }
                        }
                    }
                }
            });
        }
    }

    const handleWarningYes = (value) => {
        setModalVisible(false);
        handleLineGST(value);
    }

    const handleProductChange = (id) => {
        setLineProduct(id);
        setLineEdit(false);
        let a = myProductdetails && myProductdetails.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            if (a[0]?.batchActivation) {
                setViewBatch(true);
                setBatchOverride(true);
            } else {
                setViewBatch(false);
                setBatchOverride(false);
            }
            setLineDescription(a[0]?.description?.trim() || a[0]?.productName?.trim() || '');
            setLineBatchActivation(a[0]?.batchActivation || false);
            setLineUnitId(a[0]?.defaultPurchaseUnitId || a[0].salesUnitId);
            //setLineUseMrp(a[0]?.useMrp);
            setLineMrp(a[0]?.mrp);
            setLinePrice(a[0]?.latestPurchasePrice);
            // setLinePriceIncludesTax(a[0]?.priceIncludesTax);
            setLineUniversalProductId(a[0]?.universalProductId || '');
            dispatch({
                type: productActions.PRODUCT_PRICE_START,
                url: `/purchasedprice/${supplierId}/${id}`
            });
            if (debitNote && parameterDetails?.inventoryTransaction) {
                getProductBatch(id);
            }

            if (includeGst) {
                setLineProductGstId(a[0].productGstId ? a[0].productGstId : '');
                setLineHsnId(a[0].hsnId ? a[0].hsnId : '');
                hsnApi('', a[0].hsnId);
            }

            setLineExcisesApplicable(a[0]?.exciseApplicable || false);
            if (!a[0]?.productGstId && a[0]?.exciseApplicable) {
                setLineIncludeGst(false);
            }
        }
    }

    const getProductBatch = async (id) => {
        try {
            let f = { where: { ["and"]: [{ productId: id }, { purchaseQuantity: { gt: 0 } }, { soldQuantity: null }, { debitQuantity: null }] } };
            const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-batch-numbers/byProduct/${id}?filter=${encodeURIComponent(JSON.stringify(f))}`);
            const data = response.data;
            unstable_batchedUpdates(() => {
                setBatch(data);
                setViewBatch(true);
                setBatchOverride(true);
            });
            return data;
        } catch (error) {
            unstable_batchedUpdates(() => {
                setViewBatch(false);
                setBatch([]);
                setAutoMark(false);
                setBatchOverride(false);
            });
            return [];
        }
    }

    useEffect(() => {
        if (myProductdetails && myProductdetails?.length && lineProduct) {
            let a = myProductdetails && myProductdetails.find(function (el) { return el.id === lineProduct });
            handleUnits(a);
        }
    }, [myProductdetails, lineProduct]);


    const handleUnits = (data) => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: (data?.defaultPurchaseUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultPurchaseUnitId || data?.salesUnitId) },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: (data?.defaultPurchaseUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultPurchaseUnitId || data?.salesUnitId) }]
            }
        };
        let a = [data?.salesUnitId, data?.skuUnitId, data?.defaultPurchaseUnitId];

        getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(response => {
                let data = response.data;
                if (data && data.length > 0) {
                    data.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId);
                    });
                }
                return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
            }).then(uResponse => {
                let uData = uResponse.data;
                if (uData && uData.length > 0) {
                    uData.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId)
                    });
                }
                const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
                setUnits(filtered);
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }

    const handleStockUnits = (productId, unitId, quantity) => {
        if (productId && unitId && quantity) {
            setStockLoading(true);
            getRequest(`${process.env.REACT_APP_API_URL}/check-stock-units/?productId=${productId}&unitId=${unitId}&quantity=${quantity}`)
                .then(response => {
                    let data = response.data;
                    unstable_batchedUpdates(() => {
                        setLineStock(data);
                        setStockLoading(false);
                    });
                }).catch(error => {
                    console.error("Error fetching data", error);
                    setStockLoading(false);
                });
        }
    }

    const calculateTotal = () => {
        //if (lineQuantity > 0) {
        setLineCgst('');
        setLineSgst('');
        setLineIgst('');
        setLineCgstAmount('');
        setLineSgstAmount('');
        var amount = parseFloat(lineQuantity) * parseFloat(linePrice);
        var dPAmount = 0;
        var gAmount = 0;
        var dTotal = 0;
        setLineSalesValue(amount || '');
        // if (lineUseMrp && lineMrp !== '' && parseFloat(lineMrp) < parseFloat(linePrice)) {
        //     toast.dismiss();
        //     toast.warning('Unit price is greater than MRP Price');
        // }

        if (lineDiscountPercentage !== '') {
            dPAmount = dTotal = parseFloat((amount * lineDiscountPercentage) / 100);
        }

        let discountAmount = lineDiscountAmount;
        if (lineDiscountType === 'perUnit') {
            const qty = parseFloat(lineQuantity || 0);
            const rate = parseFloat(lineDiscountRate || 0);
            discountAmount = Math.abs(qty) * Math.abs(rate);
            setLineDiscountAmount(discountAmount);
        }

        if (discountAmount !== '') {
            if (amount < 0) {
                dTotal = parseFloat(dPAmount) - parseFloat(discountAmount);
            } else {
                dTotal = parseFloat(dPAmount) + parseFloat(discountAmount);
            }
            // dTotal = parseFloat(dPAmount) + parseFloat(lineDiscountAmount);
        }
        var lineAmount = amount - dTotal;

        // if (lineAmount < 0) {
        setLineAmount(lineAmount);
        //     toast.dismiss();
        //     toast('Line amount cannot be less than zero.');
        //     return false;
        // }

        if (lineProductGstId !== '' && lineIncludeGst) {
            if (gstCodeId === '') {
                setLineProductGstId('');
                toast.dismiss();
                toast.error('Please select party GST code');
                return false;
            }
            let party = partyGstdetails && partyGstdetails.filter(function (el) { return el.id === gstCodeId });
            if (party.length !== 0) {
                let p = party[0].productGsts && party[0].productGsts.filter(function (el) { return el.id === lineProductGstId });
                if (p && p.length !== 0) {
                    let percentage = p[0].percentage;
                    let details = {
                        percentage: percentage,
                        stateId: stateId,
                        lineAmount: lineAmount,
                        priceIncludesTax: priceIncludesTax || false
                    };
                    let gstCalc = gstCalculation(businessDetails, details, supplierDetail);
                    //let gstCalc = gstCalculation(businessDetails, details);
                    setLineCgst(gstCalc.cgst);
                    setLineSgst(gstCalc.sgst);
                    setLineCgstAmount(gstCalc.cgstAmount);
                    setLineSgstAmount(gstCalc.sgstAmount);
                    setLineIgst(gstCalc.igst);
                    setLineIgstAmount(gstCalc.igstAmount);
                    gAmount = gstCalc.gAmount;
                } else {
                    toast.dismiss();
                    toast.error('This Product GST Code is not relevant for the Chosen Party GST Code, Please Check');
                    setLineProductGstId('');
                }
            }
        }
        if (lineExcisesApplicable) {
            let excisesAmount = 0;
            let splExcisesAmount = 0;
            if (lineExcisesType === 'perUnit') {
                const qty = parseFloat(lineQuantity || 0);
                const rate = parseFloat(lineExcisesRate || 0);
                excisesAmount = Math.abs(qty) * Math.abs(rate);
                setLineExcisesAmount(excisesAmount);
            } else {
                excisesAmount = lineExcisesAmount;
            }
            if (lineSplExcisesType === 'perUnit') {
                const sqty = parseFloat(lineQuantity || 0);
                const srate = parseFloat(lineSplExcisesRate || 0);
                splExcisesAmount = Math.abs(sqty) * Math.abs(srate);
                setLineSplExcisesAmount(splExcisesAmount);
            } else {
                splExcisesAmount = lineSplExcisesAmount;
            }
            let excisesTotal = parseFloat(excisesAmount || 0) + parseFloat(splExcisesAmount || 0) + parseFloat(lineAddExcisesAmount || 0);
            setLineExcisesTotal(parseFloat(lineQuantity || 0) < 0 ? -excisesTotal : excisesTotal);
            setLineTotalCostPrice(parseFloat(lineQuantity || 0) < 0 ? -(excisesTotal - (lineAmount || 0)) : (excisesTotal + (lineAmount || 0)));
        }
        setLineGstAmount(gAmount);
        setLineDiscountPercAmount(dPAmount);
        setLineDiscountCalcAmount(dTotal);
        setLineAmount(lineAmount);
        // }
    }

    useEffect(() => {
        calculateTotal();
    }, [lineQuantity, linePrice, lineExcisesRate, lineExcisesAmount, lineSplExcisesRate, lineSplExcisesAmount, lineAddExcisesAmount, lineDiscountAmount, lineDiscountPercentage, lineProductGstId, viewVisible, visible]);


    // Compact signature over only the fields calculateGrandTotal reads, instead of
    // JSON.stringify-ing every full line object on every render.
    const linesTotalsSignature = Array.isArray(lines)
        ? lines.map(v => `${v.amount}|${v.discountAmount}|${v.quantity}|${v.pricePerUnit}|${v.discountPercent}|${v.gstAmount}|${v.excisesTotal}`).join(';')
        : '';

    useEffect(() => {
        calculateGrandTotal(lines);
    }, [linesTotalsSignature, businessDetails, cashDiscountDetails, taxCodedetails, otherTaxesdetails, tcsNameId, taxCodeId, cashDiscountId]);

    const handleProductPrice = (key) => {
        let a = unitMesurementdetails && unitMesurementdetails.filter(function (el) { return el.name === key });
        if (a && a?.length !== 0) {
            setLineUnitId(a[0]?.id);
        }
        if (productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
            productPrices?.lastprice[key]) {
            let result = productPrices?.lastprice[key];
            setLinePrice(result?.price);
            if (result?.mrp) {
                setLineMrp(result?.mrp);
            }
        }
        setUnitPriceList(false);
        setUnitPriceFocusList(false);
    }


    const changeSupplier = (value) => {
        unstable_batchedUpdates(() => {
        childRef?.current?.handleAdjustHeight();
        if (value?.isHold) {
            setErrorSupplierId('Please release the Supplier from ON-HOLD to allow for transaction to be processed.');
            setSupplierId('');
            setSupplierDetail('');
            setSupplierSerialNumber('');
            setName('');
            setAreaId('');
            setGstCodeId('');
            setPincodeId('');
            setCityId('');
            setCashDiscountAmount('');
            setCashDiscountId('');
            setStateId('');
            setCountryId('');
            setCurrencyId('');
            setMopId('');
            setTaxCodeId('');
            setTcsNameId('');
            setAddress('');
            setEmail('');
            setMobile('');
            setInAppStatus('');
            setInAppTransition(false);
            setIncludeGst('');
            setLineIncludeGst('');
        } else {
            setErrorSupplierId(false);
            if (value?.stateId) {
                changeStateApi(value?.stateId);
            }

            if (value?.pincodeId) {
                dispatch({
                    type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                        where: { ["and"]: [{ pincodeId: value?.pincodeId }] }
                    }
                });
            }
            setSupplierId(value.id);
            setSupplierDetail(value);
            setSupplierSerialNumber(value.serialNo);
            setName(value?.name || '');
            setAreaId(value.areaId);
            setGstCodeId(value.partyGstId && value.partyGstId > 0 ? value.partyGstId : '');
            setPincodeId(value.pincodeId);
            setCityId(value.cityId);
            setStateId(value.stateId);
            setCountryId(value.countryId);
            setCurrencyId(value.currencyId);
            setMopId(value.mopId > 0 ? value.mopId : '');
            setAddress(value?.address1 || '');
            setEmail(value?.email !== null || value?.email !== '' ? value?.email : '');
            setMobile(value?.mobile || '');
            setInAppStatus(value.inAppStatus);
            setInAppTransition(value?.inAppStatus === 'ACCEPTED' ? value.inAppTransition : false);
            setCashDiscountId(value?.cashDiscountId || '');
            setTaxCodeId(value?.taxCodeId || '');
            setTcsNameId(value?.tcsId || '');
            if (value?.taxType?.taxCode === 'COMP') {
                setBillFormat('billSupply');
            } else {
                // setBillFormat('format1');
                let a = customObject(templateType, businessDetails?.businessDocumentTemplates[0]?.self_bill_template);
                setBillFormat(a?.id || 'format1');
            }
            let gstSetting = includeGstSettings(value, businessDetails);
            setIncludeGst(gstSetting.includeGst);
            setIncludeDisabled(gstSetting.includeDisabled);
        }
        childRef?.current?.handleAdjustHeight();
        });
        return [];
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            setPreviewData({});
            setPreview(false);
            setConfirm(false);
            toast.dismiss();
            //toast(editDetails);
            if (roleManagement !== '' && checkCRUDPermission('Supply Self Bill', 'view', 'Purchase')) {
                history.push(`/purchase/purchase-management/self-bill/${AESEncrypt(decryptedId)}/view`, 'edit');
            } else {
                history.push(`/purchase/purchase-management/self-bill`);
            }
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            // let error = JSON.stringify(editError.error.message);
            let error = editError?.error?.message?.message || editError.error.message;
            //setCommonError(error);
            toast.dismiss();
            toast.error(error);
        }
    }, [editDetails, editError]);


    const handleLineSubmit = (e, more = false) => {
        e.preventDefault();
        let emptyDescription = emptyValidation('Description', lineDescription);
        let emptyUnit = emptyValidation('Unit', lineUnitId);
        let emptyPrice = customNumberValidation('Price', linePrice);
        let emptyQuantity = customNumberValidationQuantity('Quantity', lineQuantity);
        let emptyAmount = emptyValidation('Line Amount', lineAmount);
        let checkValidation = true;
        let emptyProductGst = emptyValidation('Product GST Code', lineProductGstId);
        let emptyHsn = emptyValidation('HSN', lineHsnId);
        if ((lineIncludeGst && !emptyProductGst.isValid) || (lineIncludeGst && !emptyHsn.isValid)) {
            checkValidation = false;
        }
        let batchQuantityError = { isValid: true, errors: '' };
        if (!debitNote) {
            if (batch.length > 0) {
                let batchQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.purchaseQuantity || 0)), 0);
                if (debitNote) {
                    batchQuantity = parseFloat(lineQuantity);
                }
                if (batchQuantity !== parseFloat(lineQuantity)) {
                    batchQuantityError = { isValid: false, errors: 'Total Batch quantity should equal Line Quantity' }
                }

                const emptyBatchNumbers = batch?.filter(item => !item.batchNumber);
                if (emptyBatchNumbers?.length) {
                    batchQuantityError = { isValid: false, errors: "Batch Number Can't be blank" }
                }
            }

            if (inAppTransition && batchOverride) {
                batchQuantityError = { isValid: false, errors: "Products with Batch activation cannot be used in bill creation against supplier with In-App enabled" }
            }
        }


        emptyLineState();
        if (emptyDescription.isValid
            && emptyUnit.isValid && emptyPrice.isValid
            && emptyQuantity.isValid && emptyAmount.isValid && checkValidation && batchQuantityError.isValid) {
            let mLines = {
                description: lineDescription.trim(),
                quantity: parseFloat(lineQuantity),
                unitId: lineUnitId,
                pricePerUnit: linePrice,
                amount: lineAmount,
                includeGst: lineIncludeGst,
                discountAmount: lineDiscountAmount ? lineDiscountAmount : 0,
                discountPercent: lineDiscountPercentage ? lineDiscountPercentage : 0,
                gstAmount: parseFloat(lineGstAmount),
                cgst: lineCgstAmount ? parseFloat(lineCgstAmount) : 0,
                sgst: lineSgstAmount ? parseFloat(lineSgstAmount) : 0,
                igst: lineIgstAmount ? parseFloat(lineIgstAmount) : 0,
                cgstPercentage: lineCgst,
                igstPercentage: lineIgst,
                sgstPercentage: lineSgst,
                maxRetailPrice: lineMrp,
                locationId: lineLocationId || '',
                batchActivation: lineBatchActivation || false,
                excisesApplicable: lineExcisesApplicable || false,
                purchaseValue: lineSalesValue || null,
                discountType: lineDiscountType || null,
                discountRate: lineDiscountRate || null
            };

            if (!debitNote && batch?.length > 0) {
                let aL = [];
                batch?.map((element, i) => {
                    if (element?.batchNumber !== '') {
                        let amount = parseFloat(parseFloat(debitNote ? (element?.debitQuantity || 0) : (element?.purchaseQuantity || 0)) * parseFloat(linePrice));
                        element.perUnitPrice = linePrice;
                        element.purchaseQuantity = parseFloat(element?.purchaseQuantity || 0);
                        element.debitQuantity = parseFloat(element?.debitQuantity || 0);
                        element.mrp = parseFloat(element?.mrp || 0);;
                        element.unitId = lineUnitId;
                        element.purchasePrice = amount - parseFloat(element?.discountAmount || 0);
                        element.businessId = getBusinessId();
                        if (debitNote) {
                            delete element.purchaseQuantity;
                        } else {
                            delete element.debitQuantity;
                        }
                        if (lineProduct) element.productId = lineProduct
                        if (lineUniversalProductId) element.universalProductId = lineUniversalProductId
                        return aL.push(element)
                    }
                });
                mLines["batchDetails"] = aL;
            }

            if (debitNote && batch?.length > 0) {
                let aL = [];
                batch?.filter(el => selectedBatchId.includes(el.id))?.map((element, i) => {
                    return aL.push(element)
                });
                mLines["batchDetails"] = aL;
            }

            if (lineExcisesApplicable) {
                mLines['excisesType'] = lineExcisesType;
                mLines['excisesRate'] = lineExcisesRate;
                mLines['excisesAmount'] = lineExcisesAmount;
                mLines['excisesSplType'] = lineSplExcisesType;
                mLines['excisesSplRate'] = lineSplExcisesRate;
                mLines['excisesSplAmount'] = lineSplExcisesAmount || '';
                mLines['excisesAddAmount'] = lineAddExcisesAmount || '';
                mLines['excisesTotal'] = lineExcisesTotal;
                mLines['totalCostPrice'] = lineTotalCostPrice || '';
            }

            if (lineProductGstId) {
                mLines["productGstId"] = lineProductGstId;
            }
            if (lineUniversalProductId) {
                mLines["universalProductId"] = lineUniversalProductId;
            }
            if (lineHsnId) {
                mLines["hsnId"] = lineHsnId;
                mLines["hsn"] = customObject(hsnDetails, lineHsnId);
            }
            if (lineProduct) {
                let d = customObject(myProductdetails, lineProduct);
                mLines["product"] = d;
                mLines["productId"] = lineProduct;
            }
            if (lineId !== '') {
                let index = lines.findIndex((d, i) => lineId === i);
                if (index >= 0) {
                    lines.splice(index, 1, mLines);
                }
            } else {
                //lines.push(mLines);
                setLines((prevState) => {
                    return [...prevState, mLines];
                });
            }
            handleClose();
            if (more) {
                // setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                    setLineNumber(parseInt(lines.length + 2));
                    setLineLocationId(lineLocationId);
                }, 500)
            }
            childRef?.current?.handleAdjustHeight();
        } else {
            if (emptyDescription.errors) {
                setErrorLineDescription(emptyDescription.errors);
            }
            if (emptyUnit.errors) {
                setErrorLineUnitId(emptyUnit.errors);
            }
            if (batchQuantityError.errors) {
                setErrorBatchQuantity(batchQuantityError.errors);
            }
            if (emptyPrice.errors) {
                setErrorLinePrice(emptyPrice.errors);
            }
            if (emptyQuantity.errors) {
                setErrorLineQuantity(emptyQuantity.errors);
            }
            if (emptyAmount.errors) {
                // setErrorLineAmount(emptyAmount.errors);
            }
            if (lineIncludeGst && !emptyProductGst.isValid) {
                setErrorLineProductGst(emptyProductGst.errors);
            }
            if (lineIncludeGst && !emptyHsn.isValid) {
                setErrorLineHsn(emptyHsn.errors);
            }
        }
    }

    const locationApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };

        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: productSetupActions.LOCATION_DETAILS_START, url: 'locations',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const handleChangeCountry = (value) => {
        setCountryId(value);
        setStateId('');
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = countryDetails && countryDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCurrencyId(a[0].currencyId);
        }
    }

    const calculateGrandTotal = (lines) => {
        if (lines && lines.length > 0) {
            let total = lines && lines.reduce((a, v) => a = a + v.amount, 0);
            let discount = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.discountAmount || 0), 0);
            // let discountPercent = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(((v.quantity * v.pricePerUnit) * v.discountPercent) / 100), 0);
            let discountPercent = lines && lines.reduce((a, v) => {
                if (v.amount < 0) {
                    a = parseFloat(a) - parseFloat(((v.quantity * v.pricePerUnit) * parseFloat(v?.discountPercent || 0)) / 100)
                } else {
                    a = parseFloat(a) + parseFloat(((v.quantity * v.pricePerUnit) * parseFloat(v?.discountPercent || 0)) / 100)
                }
                return a;
            }, 0);
            let gst = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0);
            setTotalDiscount(discount + discountPercent);
            setGstAmount(parseFloat(parseFloat(gst).toFixed(2)));
            let excisesAmount = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.excisesTotal || 0), 0);
            //
            let disAmount = 0;
            if (cashDiscountDetails && cashDiscountDetails?.length > 0) {
                let data = cashDiscountDetails.find((el) => { return el.id === cashDiscountId });
                if (data) {
                    disAmount = (total * (data?.percentage || 0)) / 100;
                }
            }
            setCashDiscountAmount(disAmount);
            setExcisesAmount(excisesAmount);
            //  if (excisesAmount) {
            let assessableAmount = parseFloat(total || 0) - parseFloat(disAmount || 0) + parseFloat(excisesAmount || 0);

            if (priceIncludesTax) {
                assessableAmount = parseFloat(assessableAmount || 0) - parseFloat(gst || 0);
            }

            setAssessableValue(parseFloat(parseFloat(assessableAmount).toFixed(2)));
            let taxValue = 0;
            if (taxCodedetails && taxCodedetails?.length > 0) {
                let data = taxCodedetails.find((el) => { return el.id === taxCodeId });
                if (data) {
                    taxValue = ((assessableAmount || 0) * (data?.percentage || 0)) / 100;
                    setTax(taxValue);
                }
            }

            // let tcsValue = 0;
            // let tcsAmount = parseFloat(assessableAmount || 0) + parseFloat(taxValue || 0);
            // if (supplierDetail.tcsBoolean) {
            //     tcsValue = (tcsAmount * (supplierDetail?.tcs?.percentage || 0)) / 100;
            //     setTcs(tcsValue);
            // }

            let tcsValue = 0;
            let tcsAmount = parseFloat(assessableAmount || 0) + parseFloat(taxValue || 0);
            if (supplierDetail.tcsBoolean) {
                let data = otherTaxesdetails.find((el) => { return el.id === tcsNameId });
                tcsValue = (tcsAmount * (data?.percentage || 0)) / 100;
                setTcs(tcsValue);
            }
            total = parseFloat(assessableAmount || 0) + parseFloat(taxValue || 0) + parseFloat(tcsValue || 0);
            //  }
            //  let totalNetAmount = lines && lines.reduce((a, v) => a = a + v.amount, 0);
            // if (priceIncludesTax) {
            //     setTotal(parseFloat(parseFloat(total + roundOffAmount).toFixed(2)));
            //     setTotalInvoice(parseFloat(parseFloat(total).toFixed(2)));
            //     if (excisesAmount) {
            //         setNetAmount(parseFloat(parseFloat(totalNetAmount - gst).toFixed(2)));
            //     } else {
            //         setNetAmount(parseFloat(parseFloat(total - gst).toFixed(2)));
            //     }
            // } else {
            //     setTotal(parseFloat(parseFloat(total + gst + roundOffAmount).toFixed(2)));
            //     setTotalInvoice(parseFloat(parseFloat(total + gst).toFixed(2)));
            //     if (excisesAmount) {
            //         setNetAmount(parseFloat(parseFloat(totalNetAmount).toFixed(2)));
            //     } else {
            //         setNetAmount(parseFloat(parseFloat(total).toFixed(2)));
            //     }
            // }

            setTotal(parseFloat(parseFloat(total + gst + (parseFloat(roundOffAmount || 0))).toFixed(2)));
            setTotalInvoice(parseFloat(parseFloat(total + gst).toFixed(2)));
            setNetAmount(parseFloat(parseFloat(assessableAmount).toFixed(2)));

        } else {
            setTotal(0);
            setTotalDiscount(parseFloat(0.00));
            setGstAmount(parseFloat(0.00));
            setNetAmount(parseFloat(0.00));
            setExcisesAmount(parseFloat(0.00));
            setAssessableValue(parseFloat(0.00));
            setTax(parseFloat(0.00));
        }
    }

    const changeArea = (value) => {
        setAreaId(value);
    }

    const onEdit = (data, i) => {
        if (!supplierId) {
            toast.dismiss();
            toast.error('Please Select Supplier');
            return true;
        }

        setPrimaryTitle('Edit');
        setLineId(i);
        setLineNumber(parseInt(i + 1));
        setLineProduct(data?.productId || '');
        setLineBatchActivation(data?.product?.batchActivation || data?.batchActivation || false);
        setLineLocationId(data?.locationId || '');
        setLineDescription(data.description);
        setLineQuantity(data.quantity);
        setLineUnitId(data.unitId);
        productApi('', data.productId);
        setLineSalesValue(data?.purchaseValue || '');
        setLinePrice(data.pricePerUnit);
        setInvoiceDate(readDetails?.invoiceDate ? dayjs(readDetails?.invoiceDate).$d : new Date());
        setBatch([]);
        setLineStock({
            unitId: data?.stockUnitId || '',
            quantity: data?.stockQuantity || '',
            unit: data?.stockUnit || ''
        });
        setDebitBatch(false);
        setViewBatch(false);
        setBatchOverride(false);
        if (!debitNote && data?.batchDetails) {
            let a = [];
            data.batchDetails?.map((el) => {
                a.push({
                    ...el,
                    expiryDate: el?.expiryDate ? dayjs(el?.expiryDate).$d : new Date(),
                    manufacturingDate: el?.manufacturingDate ? dayjs(el?.manufacturingDate).$d : new Date(),
                    useByDate: el?.useByDate ? dayjs(el?.useByDate).$d : new Date()
                })
            });

            setBatch(a);
            setViewBatch(true);
            setBatchOverride(true);
        }
        if (debitNote && data?.batchDetails) {
            let a = []; let ids = [];
            data.batchDetails?.map((el) => {
                ids.push(el.id);
                a.push({
                    ...el,
                    expiryDate: el?.expiryDate ? dayjs(el?.expiryDate).$d : new Date(),
                    manufacturingDate: el?.manufacturingDate ? dayjs(el?.manufacturingDate).$d : new Date(),
                    useByDate: el?.useByDate ? dayjs(el?.useByDate).$d : new Date()
                })
            });

            setBatch(a);
            setSelectedBatchId(ids);
            setViewBatch(true); setBatchOverride(true);
        }
        if (debitNote && data?.batchDetailsDebit) {
            let a = []; let ids = [];
            data.batchDetailsDebit?.map((el) => {
                ids.push(el.id);
                a.push({
                    ...el,
                    expiryDate: el?.expiryDate ? dayjs(el?.expiryDate).$d : new Date(),
                    manufacturingDate: el?.manufacturingDate ? dayjs(el?.manufacturingDate).$d : new Date(),
                    useByDate: el?.useByDate ? dayjs(el?.useByDate).$d : new Date()
                })
            });
            setDebitBatch(true);
            setBatch(a);
            setSelectedBatchId(ids);
            setViewBatch(true);
            setBatchOverride(true);
        }
        locationApi();
        setLineDiscountType(data?.discountType || '');
        setLineDiscountRate(data?.discountRate || '');
        setLineDiscountAmount(data.discountAmount);
        setLineDiscountPercentage(data.discountPercent);
        setLineIncludeGst(data.includeGst ? true : false);
        //  setLineIncludeGst(includeGst ? true : false);
        setLineProductGstId(data.productGstId ? data.productGstId : '');
        setLineHsnId(data.hsnId ? data.hsnId : '');
        hsnApi('', data.hsnId);
        setLineMrp(data.maxRetailPrice ? data.maxRetailPrice : '');
        setVisible(true);
        setLineEdit(true);
        setLineExcisesApplicable(data?.excisesApplicable || false);
        if (data?.excisesApplicable) {
            setLineExcisesAmount(data?.excisesAmount);
            setLineExcisesType(data?.excisesType);
            setLineSplExcisesType(data?.excisesSplType)
            setLineExcisesRate(data?.excisesRate);
            setLineSplExcisesRate(data?.excisesSplRate);
            setLineSplExcisesAmount(data?.excisesSplAmount);
            setLineAddExcisesAmount(data?.excisesAddAmount);
        }
        if (data.productId) {
            dispatch({
                type: productActions.PRODUCT_PRICE_START,
                url: `/purchasedprice/${supplierId}/${data.productId}`
            });
        }
    }

    const onEditButton = () => {
        setViewVisible(false);
        setVisible(true);
    }

    const onView = (data, i) => {
        if (!supplierId) {
            toast.dismiss();
            toast.error('Please Select Supplier'); return true;
        }

        setLineId(i);
        setViewVisible(true);
        setLineNumber(parseInt(i + 1));
        setLineProduct(data.productId);
        setLineBatchActivation(data?.product?.batchActivation || data?.batchActivation || false);
        setLineLocationId(data?.locationId || '');
        setLineDescription(data.description);
        setLineQuantity(data.quantity);
        setLineUnitId(data.unitId);
        setLineDiscountType(data?.discountType || '');
        setLineDiscountRate(data?.discountRate || '');
        productApi('', data.productId);
        setLinePrice(data.pricePerUnit);
        setLineAmount(data.amount);
        setLineSalesValue(data?.purchaseValue || '');
        setLineDiscountAmount(data.discountAmount);
        setLineDiscountPercentage(data.discountPercent);
        setLineIncludeGst(data.includeGst ? true : false);
        //setLineIncludeGst(includeGst ? true : false);

        setLineProductGstId(data.productGstId ? data.productGstId : '');
        setLineHsnId(data.hsnId ? data.hsnId : '');
        setLineMrp(data.maxRetailPrice ? data.maxRetailPrice : '');
        setInvoiceDate(readDetails?.invoiceDate ? dayjs(readDetails?.invoiceDate).$d : new Date());
        hsnApi('', data.hsnId); locationApi();
        setBatch([]);
        setDebitBatch(false);
        setViewBatch(false);
        setBatchOverride(false);
        if (!debitNote && data?.batchDetails) {
            setBatch(data.batchDetails);
            setViewBatch(true);
            setBatchOverride(true);
        } else if (debitNote && data?.batchDetails) {
            let a = [];
            data.batchDetails?.map((el) => {
                a.push({
                    ...el,
                    debitQuantity: el.purchaseQuantity,
                    expiryDate: el?.expiryDate ? dayjs(el?.expiryDate).$d : new Date(),
                    manufacturingDate: el?.manufacturingDate ? dayjs(el?.manufacturingDate).$d : new Date(),
                    useByDate: el?.useByDate ? dayjs(el?.useByDate).$d : new Date()
                })
            });
            setBatch(a);
            setViewBatch(true);
            setBatchOverride(true);
        } else if (data?.batchDetailsDebit) {
            setBatch(data.batchDetailsDebit);
            setDebitBatch(true);
            setViewBatch(true);
            setBatchOverride(true);
        } else {
            setBatch([]);
            setViewBatch(data?.product?.batchActivation || data?.batchActivation || false);
            setBatchOverride(data?.product?.batchActivation || data?.batchActivation || false);
        }
        setLineEdit(true);
        if (data?.productId) {
            dispatch({
                type: productActions.PRODUCT_PRICE_START,
                url: `/purchasedprice/${supplierId}/${data.productId}`
            });
        }
        if (readDetails?.isViaNotification) {
            setNotificationLineCgstAmount(data?.cgst);
            setNotificationLineIgstAmount(data?.igst);
            setNotificationLineSgstAmount(data?.sgst);
            setNotificationLineGstAmount(data?.gstAmount);
        }
        setLineExcisesApplicable(data?.excisesApplicable || false);

        if (data?.excisesApplicable) {
            setLineExcisesAmount(data?.excisesAmount);
            setLineExcisesType(data?.excisesType);
            setLineSplExcisesType(data?.excisesSplType)
            setLineExcisesRate(data?.excisesRate);
            setLineSplExcisesRate(data?.excisesSplRate);
            setLineSplExcisesAmount(data?.excisesSplAmount);
            setLineAddExcisesAmount(data?.excisesAddAmount);
        }
    }

    const handleLineDiscountRateChange = (value) => {
        let va = value < 0 ? 0 : value;
        setLineDiscountRate(va);
        if (lineDiscountType === 'perUnit') {
            setLineDiscountAmount(parseFloat(parseFloat(va * (lineQuantity || 0)).toFixed(2)));
        }
    }


    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const deleteLine = () => {
        let index = lines.findIndex((d, i) => lineId === i);
        if (index >= 0) {
            lines.splice(index, 1);
        }
        setIsModalVisible(false);
    }

    const onDelete = (data, i) => {
        setIsModalVisible(true);
        setLineId(i);
        setLineDescription(data.description);
    }

    const handleAddMore = (e) => {
        handleLineSubmit(e, true);

    }


    const customObject = (details, id) => {
        if (!Array.isArray(details) || details.length === 0 || id === '' || id === undefined || id === null) {
            return EMPTY_RESULT;
        }
        let idMap = objectIdCache.get(details);
        if (!idMap) {
            idMap = new Map();
            for (let i = 0; i < details.length; i++) {
                const el = details[i];
                if (el && !idMap.has(el.id)) {
                    idMap.set(el.id, el);
                }
            }
            objectIdCache.set(details, idMap);
        }
        return idMap.has(id) ? idMap.get(id) : EMPTY_RESULT;
    }

    const handleLineIncludeGst = (value) => {
        setLineIncludeGst(value);
        setErrorLineProductGst(false);
        setErrorLineHsn(false);
        if (value && lineIncludeGst !== '') {
            let party = partyGstdetails && partyGstdetails.filter(function (el) { return el.id === gstCodeId });
            if (party.length !== 0) {
                let p = party[0].productGsts && party[0].productGsts.filter(function (el) { return el.id === lineProductGstId });
                if (p.length !== 0) {
                    let percentage = p[0].percentage;
                    let details = {
                        percentage: percentage,
                        stateId: stateId,
                        lineAmount: lineAmount,
                        priceIncludesTax: priceIncludesTax || false
                    };
                    let gstCalc = gstCalculation(businessDetails, details, supplierDetail);
                    //let gstCalc = gstCalculation(businessDetails, details);
                    setLineCgst(parseFloat(gstCalc?.cgst || 0));
                    setLineSgst(parseFloat(gstCalc.sgst || 0));
                    setLineCgstAmount(parseFloat(gstCalc.cgstAmount || 0));
                    setLineSgstAmount(parseFloat(gstCalc.sgstAmount || 0));
                    setLineIgst(parseFloat(gstCalc.igst || 0));
                    setLineIgstAmount(parseFloat(gstCalc.igstAmount || 0));
                    setLineGstAmount(parseFloat(gstCalc.gAmount || 0));
                }
            }
        } else {
            setLineGstAmount(0);
            setLineCgst(0);
            setLineSgst(0);
            setLineIgst(0);
            setLineCgstAmount(0);
            setLineSgstAmount(0);
            setLineIgstAmount(0);
        }
    }

    const classes = customStyles();


    const handleModalClose = (o) => {
        setOpen(o); setPreview(false);
    };

    const changePincode = (value) => {
        setPincodeId(value);
        setAreaId('');
        let a = pincodeDetails && pincodeDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCityId(a[0].cityId);
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { ["and"]: [{ pincodeId: value }] }
                }
            });
        }
        return [];
    }

    const changeCity = (value) => {
        setCityId(value);
        setAreaId('');
        setPincodeId('');
    }

    const changeState = (value) => {
        setStateId(value);
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = stateDetails && stateDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCountryId(a[0].countryId);
            setCurrencyId(a[0].country && a[0].country.currencyId);
        }
        changeStateApi(value);
        return [];
    }

    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
    }

    const handleProductTextChange = (value) => {
        if (value === '') {
            setLineDescription('');
            setLineUnitId('');
            setLineUnitId('');
            //setLineUseMrp('');
            setLineMrp();
            //setLinePriceIncludesTax(false);
            setLineUniversalProductId('');
            setLineProduct('');
            setLineBatchActivation(false);
            dispatch({ type: productActions.CLEAR_PRICE_START });
            if (includeGst) {
                setLineProductGstId('');
                setLineHsnId('');
            }
        }
    }

    const handleLineUnit = (data) => {
        setLineUnitId(data.id);
        handleSetProductPrice(data.id, false);
        handleStockUnits(lineProduct, data.id, lineQuantity);
    }

    const handleChange = (newValue) => {
        setValue(newValue);
        childRef?.current?.handleAdjustHeight();
        storageSetItem('purchaseView', newValue);
    };

    const handleTaxCode = (data) => {
        setTaxCodeId(data?.id);
        const value = (assessableValue * (data.percentage || 0)) / 100;
        setTax(value);
    }


    const handleBulkLineSubmit = (selected) => {
        setLines(selected);
        setProductsVisible(false);
    }

    const handleRoundOff = (data) => {
        setRoundOffMethod(data.id);
        let value = 0;
        if (totalInvoice && data?.id) {
            if (data.id === 'UP') {
                value = Math.ceil(totalInvoice);
            } else {
                value = Math.floor(totalInvoice);
            }
            setRoundOffAmount(parseFloat(parseFloat(value - totalInvoice).toFixed(2)));
            setTotal(parseFloat(parseFloat(value).toFixed(2)));
        } else {
            setRoundOffAmount(0);
            setTotal(parseFloat(parseFloat(totalInvoice).toFixed(2)));
        }
    }

    const addBatch = () => {
        setBatch((prevState) => {
            return [...prevState, { batchNumber: '', purchaseQuantity: debitNote ? -1 : 1, debitQuantity: debitNote ? -1 : 1, manufacturingDate: parameterDetails?.batchMfgDate ? new Date() : null, expiryDate: parameterDetails?.batchExpiryDate ? new Date() : null, useByDate: new Date() }];
        });
    }

    // const changeHandlerBatch = (data, e, name, i) => {
    //     const newTodos = batch.map((el) => {
    //         if (el.batchNumber === data.batchNumber) {
    //             return { ...el, [name]: e };
    //         }
    //         return el;
    //     });
    //     setBatch(newTodos);
    // }

    const changeHandlerBatch = (data, e, name, i) => {
        // Create a shallow copy of the array
        const updatedArr = [...batch];

        // Update the specific element immutably
        updatedArr[i] = {
            ...updatedArr[i],
            [name]: e,
        };

        // Update state with the new array
        setBatch(updatedArr);
    };

    const handleBulkClick = (value) => {
        if (value) {
            setSelectedBatchId(batch.map(el => el.id));
            let qyt = batch.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.purchaseQuantity || 0), 0)
            setLineQuantity(-qyt);
        } else {
            setSelectedBatchId([]);
            setLineQuantity(0);
        }
    }

    const handleClick = (id) => {
        const isSelected = selectedBatchId.includes(id);
        let newSelected;

        if (!isSelected) {
            // Checked (select)
            newSelected = [...selectedBatchId, id];

        } else {
            // UnChecked (deselect)
            newSelected = selectedBatchId.filter(batchId => batchId !== id);
        }
        setSelectedBatchId(newSelected);
        let qyt = batch.filter(el => newSelected.includes(el.id)).reduce((a, v) => a = parseFloat(a) + parseFloat(v?.purchaseQuantity || 0), 0)
        setLineQuantity(-qyt);
    }

    const onDeletBatch = (data) => {
        let selectedSingleIndex = batch?.findIndex(el => el.batchNumber === data.batchNumber);
        let selectedSingle = batch?.find(el => el.batchNumber === data.batchNumber);
        if (selectedSingleIndex >= 0) {
            if (selectedSingle?.id) {
                deleteRequest(`product-batch-numbers/${selectedSingle.id}`).then(uResponse => {
                    setBatch(prevState => {
                        return prevState.filter((value, i) => i !== selectedSingleIndex)
                    });
                }).catch(error => {
                    toast.dismiss();
                    if (error.response && error.response.status === 409) {
                        toast.error("Cannot delete batch: stock is available.");
                    } else {
                        toast.error("Error deleting batch:");
                    }
                });
            }
            setErrorBatchQuantity(false);
        }
        return false;
    }

    const isSelected = (id) => selectedBatchId.indexOf(id) !== -1;

    // --- Stable props for the dropdowns, so React.memo on AutoCompleteComponent can skip
    // re-rendering them when unrelated form state changes. ---
    const productHeads = showNameDesc === 'name' ? PRODUCT_HEADS_NAME : PRODUCT_HEADS_DESC;

    // Derived dropdown option lists, memoized so their reference is stable (an inline
    // .filter()/`|| []` would allocate a new array each render and defeat the memoized dropdown).
    const tcsOptions = useMemo(() => (otherTaxesdetails || []).filter(el => el.taxType === 'TCS'), [otherTaxesdetails]);
    const cashDiscountOptions = useMemo(() => cashDiscountDetails || [], [cashDiscountDetails]);
    const unitOptions = useMemo(
        () => (parameterDetails?.inventoryTransaction ? units : unitMesurementdetails),
        [parameterDetails, units, unitMesurementdetails]
    );

    // Name labels that embed JSX (a required asterisk), memoized for a stable reference.
    const supplierNameLabel = useMemo(() => ["Supplier Name ", <span key={"Supplier Name"} className={classes.colorRedRequired}> *</span>], [classes.colorRedRequired]);
    const currencyNameLabel = useMemo(() => ["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>], [classes.colorRedRequired]);
    const stateNameLabel = useMemo(() => ["State/Province ", <span key={"State/Province"} className={classes.colorRedRequired}> *</span>], [classes.colorRedRequired]);
    const pincodeNameLabel = useMemo(() => ["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>], [classes.colorRedRequired]);
    const unitNameLabel = useMemo(() => ["Unit ", <span key={"Unit"} className={classes.colorRedRequired}> *</span>], [classes.colorRedRequired]);

    // Stable handlers. useStableCallback always invokes the latest closure, so no stale state.
    const stableChangeSupplier = useStableCallback((data) => { changeSupplier(data); });
    const stableSupplierApi = useStableCallback((s) => supplierApi(s));
    const stableBillFormatPreview = useStableCallback((data) => { setBillFormat(data.id); handlePreview(); });
    const stableRoundOff = useStableCallback((data) => handleRoundOff(data));
    const stableCashDiscountChange = useStableCallback((data) => setCashDiscountId(data.id));
    const stableTaxCodeChange = useStableCallback((data) => handleTaxCode(data));
    const stableTcsChange = useStableCallback((data) => setTcsNameId(data?.id));
    const stableMopChange = useStableCallback((data) => setMopId(data.id));
    const stableCurrencyChange = useStableCallback((data) => setCurrencyId(data.id));
    const stableGstCodeChange = useStableCallback((data) => setGstCodeId(data.id));
    const stableStateChange = useStableCallback((data) => changeState(data.id));
    const stableCountryChange = useStableCallback((data) => handleChangeCountry(data.id));
    const stablePincodeChange = useStableCallback((data) => changePincode(data.id));
    const stableCityChange = useStableCallback((data) => changeCity(data.id));
    const stableAreaChange = useStableCallback((data) => { changeArea(data.id); });
    const stableHandleProductChange = useStableCallback((data) => handleProductChange(data.id));
    const stableHandleProductTextChange = useStableCallback((value) => handleProductTextChange(value));
    const stableProductApi = useStableCallback((s) => productApi(s));
    const stableLineUnitChange = useStableCallback((data) => handleLineUnit(data));
    const stableLocationChange = useStableCallback((data) => setLineLocationId(data.id));
    const stableLocationApi = useStableCallback((s) => locationApi(s));
    const stableLineProductGstChange = useStableCallback((data) => setLineProductGstId(data.id));
    const stableLineHsnChange = useStableCallback((data) => setLineHsnId(data.id));
    const stableHsnApi = useStableCallback((s) => hsnApi(s));

    // var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    return (
        <React.Fragment>
            <MainHeader  {...props} autoMark={autoMark}
                closeLink={'/purchase/purchase-management/self-bill'}
                img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Supply Self Bill', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Edit Supply Self Bill'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        ref={childRef}
                        component={
                            <>
                                {
                                    readLoader === false && readDetails && (
                                        <Box
                                            className={clsx(classes.removeUnderline, classes.positionRelative)}
                                            component="form"
                                            autoComplete="off"
                                            onSubmit={(e) => handleSubmit(e, status)}>
                                            {
                                                commonError && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <CustomAlert error={commonError} customClass={clsx(classes.uploadError, classes.marginBottom20)} />
                                                </Col>
                                            }
                                            <div className={clsx(classes.tabWrapSubmit, classes.vertiCalScrollOverFlow)}>
                                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                                    <div className={classes.templateView}>
                                                        {
                                                            readDetails.isViaNotification ?
                                                                <NavLink to="#" onClick={() => handlePreview()}
                                                                    tabIndex={-1}
                                                                >
                                                                    <Image className={""} src={ViewIcon} preview={false} />
                                                                    <span>Invoice Template {customObject(templateType, billFormat)?.label}</span>
                                                                </NavLink> : <>
                                                                    <NavLink to="#" onClick={() => handlePreview()} tabIndex={-1}>
                                                                        <Image className={""} src={ViewIcon} preview={false} />
                                                                        <span className={classes.customerInvoiceNone}>Invoice Template</span>
                                                                    </NavLink>
                                                                    <AutoCompleteComponent
                                                                        name={""}
                                                                        heads={HEADS_LABEL}
                                                                        details={templateType}
                                                                        id={idNamingConversion('billFormat', 'purchaseBill', 'DropDown')}
                                                                        parentValue={customObject(templateType, billFormat)}
                                                                        onChange={stableBillFormatPreview}
                                                                        position={'bottom'}
                                                                        disabled={supplierDetail?.taxType?.taxCode === 'COMP' ? true : false}
                                                                        customClasses={clsx(classes.customAutocomplete, classes.customerInvoice)}
                                                                    />
                                                                </>
                                                        }
                                                    </div>
                                                    <Button
                                                        tabIndex={-1}
                                                        key="confirm"
                                                        type="submit"
                                                        color="primary"
                                                        variant="contained"
                                                        id={idNamingConversion('Update', 'purchaseBill', 'Button')}
                                                        className={clsx(classes.AddMoreBtn, { [classes.loading]: editLoader })}
                                                    >Update</Button>
                                                    {
                                                        viewStatus === 'CREATED' && (
                                                            roleManagement !== '' && checkComponentPermission('Supply Self Bill', 'Action', 'Confirm') &&
                                                            <Button
                                                                tabIndex={-1}
                                                                key="save"
                                                                color="primary"
                                                                variant="contained"
                                                                onClick={() => handleConfirmSubmit()}
                                                                id={idNamingConversion('Confirm', 'purchaseBill', 'Button')}
                                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader }, { [classes.disabled]: lines.length === 0 })}
                                                            >Confirm</Button>
                                                        )
                                                    }
                                                </Space>
                                            </div>
                                            <div className={classes.tabDesign}>
                                                <TabContext value={value}>
                                                    <TabList onChange={(event, newValue) => handleChange(newValue)}>
                                                        <Tab className={classes.Bordertab_1} label="Line View" value={"lineView"} />
                                                        <Tab className={classes.Bordertab_2} label="Header View" value={"headerView"} />
                                                    </TabList>
                                                    <TabPanel value={"lineView"}>
                                                        <Row>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={50}>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Row gutter={50}>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Supply Bill Number</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{serialNumber ? serialNumber : '---'} </Typography>
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={65} sm={12} xs={24}>
                                                                        <Row>
                                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                                                <InputLabel className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Supplier ID</InputLabel>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{supplierSerialNumber ? supplierSerialNumber : '---'}</Typography>
                                                                            </Col>
                                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={classes.textAlignRight}>
                                                                                <span className={clsx(classes.statusButton, classes.margin20t, { [classes.confirmedButton]: viewStatus === 'CONFIRMED' },
                                                                                    { [classes.reversedButton]: viewStatus === 'REVERSED' }, { [classes.cancelledButton]: viewStatus === 'CANCELLED' })}>{capitalizeFirstLetter(viewStatus)}</span>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <FormControlLabel
                                                                            classes={{
                                                                                label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                                                            }}
                                                                            control={<Switch size='small'
                                                                                className={clsx(classes.customSwitch)}
                                                                                onChange={(e) => { setInAppTransition(!inAppTransition); }}
                                                                            />}
                                                                            id={idNamingConversion('In-AppTransactions', 'purchaseBill', 'Radio')}
                                                                            label="In-AppTransactions"
                                                                            labelPlacement="top"
                                                                            checked={inAppTransition}
                                                                            disabled={inAppStatus === 'ACCEPTED' ? false : true}
                                                                            className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <FormControlLabel
                                                                            classes={{
                                                                                label: clsx(classes.fonSize13)
                                                                            }}
                                                                            control={<Switch size='small'
                                                                                className={clsx(classes.customSwitch)}
                                                                                onChange={(e) => setPriceIncludesTax(!priceIncludesTax)}
                                                                                checked={priceIncludesTax || false}
                                                                            />}
                                                                            id={idNamingConversion('Price Includes Tax', 'purchaseBill', 'Radio')}
                                                                            label="Price Includes Tax"
                                                                            labelPlacement="top"
                                                                            disabled={lines?.length > 0 ? true : false}
                                                                            className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={4} xl={4} lg={4} md={24} sm={24} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Supplier Ref Number</Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.supplierRefNum || '---'}</Typography>
                                                                            </> :
                                                                                <TextField autoComplete='one-time-code'
                                                                                    label={inAppTransition ? "Supplier Ref Number" : ["Supplier Ref Number ", <span key={"Supplier Ref Number"} className={classes.colorRedRequired}> *</span>]}
                                                                                    fullWidth
                                                                                    className={clsx(classes.margin20t)}
                                                                                    variant={'standard'}
                                                                                    error={errorSupplierRefNum && true}
                                                                                    helperText={errorSupplierRefNum}
                                                                                    value={supplierRefNum}
                                                                                    placeholder={"Enter Supplier Invoice number"}
                                                                                    id={idNamingConversion('Supplier Ref Number', 'purchaseBill', 'TextField')}
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor
                                                                                        }
                                                                                    }}
                                                                                    inputProps={{ maxLength: 30 }}
                                                                                    InputLabelProps={{
                                                                                        className: classes.textFieldLableColorCustom,
                                                                                    }}
                                                                                    disabled={inAppTransition}
                                                                                    onChange={(e) => setSupplierRefNum(e.target.value)}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Supplier Name </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.name}</Typography>
                                                                            </> : <AutoCompleteComponent
                                                                                name={supplierNameLabel}
                                                                                heads={SUPPLIER_HEADS}
                                                                                details={supplierDetails}
                                                                                id={idNamingConversion('Supplier Name', 'purchaseBill', 'DropDown')}
                                                                                parentValue={customObject(supplierDetails, supplierId)}
                                                                                onChange={stableChangeSupplier}
                                                                                searchType={stableSupplierApi}
                                                                                parentError={errorSupplierId}
                                                                                position={"bottom"}
                                                                                customClasses={classes.margin20t}
                                                                            />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Phone Number </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.phone}</Typography>
                                                                            </> :
                                                                                <TextField autoComplete='one-time-code'
                                                                                    label={["Phone Number ", <span key={"Phone Number"} className={classes.colorRedRequired}> *</span>]}
                                                                                    fullWidth
                                                                                    // type="number"
                                                                                    id={idNamingConversion('Phone Number', 'purchaseBill', 'TextField')}
                                                                                    className={clsx(classes.margin20t)}
                                                                                    variant={'standard'}
                                                                                    error={errorMobile && true}
                                                                                    helperText={errorMobile}
                                                                                    value={mobile || ''}
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor
                                                                                        }
                                                                                    }}
                                                                                    InputLabelProps={{
                                                                                        className: classes.textFieldLableColorCustom
                                                                                    }}
                                                                                    onChange={(e) => setMobile(e.target.value)}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Created By</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.createdBy || '----'}</Typography>
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <div className={clsx(classes.margin20t, classes.dateAdjust)} tabIndex={-1}>
                                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                <DesktopDatePicker
                                                                                    fullWidth
                                                                                    slots={{
                                                                                        openPickerIcon: DateIcon
                                                                                    }}
                                                                                    views={['year', 'month', 'day']}
                                                                                    value={invoiceDate}
                                                                                    //minDate={transactionDate}
                                                                                    //maxDate={new Date(y, m + 1, 0)}
                                                                                    label="Invoice Date"
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor,
                                                                                        }
                                                                                    }}
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            id: idNamingConversion('Invoice Date', 'purchaseBill', 'TextField'),
                                                                                            autoComplete: 'one-time-code'
                                                                                        },
                                                                                    }}
                                                                                    //readOnly={true}
                                                                                    format="dd/MM/yyyy"
                                                                                    // onChange={(newValue) => {
                                                                                    //     (newValue === null || newValue == 'Invalid Date') ? setInvoiceDate(new Date()) : setInvoiceDate(newValue)
                                                                                    // }}
                                                                                    onChange={(newValue, newError) => {
                                                                                        if (newError?.validationError || newValue === null) {
                                                                                            setInvoiceDate(new Date())
                                                                                        } else {
                                                                                            setInvoiceDate(newValue)
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </LocalizationProvider>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                                                                        <div className={clsx(classes.margin20t, classes.dateAdjust, classes.closeBackGround)}>
                                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                <DesktopDatePicker
                                                                                    fullWidth
                                                                                    slots={{
                                                                                        openPickerIcon: DateIcon
                                                                                    }}
                                                                                    views={['year', 'month', 'day']}
                                                                                    minDate={new Date(invoiceDate)}
                                                                                    allowKeyboardControl={false}
                                                                                    value={dueDate}
                                                                                    label="Due Date"
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor,
                                                                                        },
                                                                                    }}
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            error: errorDueDate ? true : false,
                                                                                            helperText: errorDueDate,
                                                                                            id: idNamingConversion('Due Date', 'purchaseBill', 'TextField'),
                                                                                            autoComplete: 'one-time-code'
                                                                                        },
                                                                                    }}
                                                                                    format="dd/MM/yyyy"
                                                                                    // onChange={(newValue) => {
                                                                                    //     (newValue === null || newValue == 'Invalid Date') ? setDueDate(new Date()) : setDueDate(newValue)
                                                                                    // }}
                                                                                    onChange={(newValue, newError) => {
                                                                                        if (newError?.validationError || newValue === null) {
                                                                                            setDueDate(new Date());
                                                                                        } else {
                                                                                            setDueDate(newValue);
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </LocalizationProvider>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                        <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Totals</Typography>
                                                                    </Col>
                                                                    {parameterDetails?.purchaseValue &&
                                                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Purchase Total</Typography>
                                                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹  {currencyFormat(lines.length > 0 ? lines?.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.purchaseValue || 0), 0) : 0)}</Typography>
                                                                        </Col>
                                                                    }

                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Discount</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹  {currencyFormat(totalDiscount)}</Typography>
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Net Amount</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(netAmount)}</Typography>
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                                            <span>GST Amount </span>
                                                                            <Tooltip
                                                                                classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                                                title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                                                <IconButton>
                                                                                    <Image src={infoMarkIcon} preview={false} />
                                                                                </IconButton>
                                                                            </Tooltip></Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(gstAmount)}</Typography>
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <Row>
                                                                            <Col xxl={6} xl={6} lg={10} md={10} sm={6} xs={6}>
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_ROUND_OFF}
                                                                                    heads={HEADS_NAME}
                                                                                    details={ROUNDOFF_OPTIONS}
                                                                                    parentValue={customObject(ROUNDOFF_OPTIONS, roundOffMethod)}
                                                                                    onChange={stableRoundOff}
                                                                                    position={"bottom"}
                                                                                    id={idNamingConversion('Round off', 'purchaseBill', 'DropDown')}
                                                                                    disabled={readDetails?.isViaNotification ? true : false}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                            </Col>
                                                                            <Col xxl={18} xl={18} lg={14} md={14} sm={18} xs={18}>
                                                                                <TextField autoComplete='one-time-code'
                                                                                    label={[""]}
                                                                                    fullWidth
                                                                                    type="number"
                                                                                    className={clsx(classes.margin20t)}
                                                                                    error={errorRoundOffAmount && true}
                                                                                    helperText={errorRoundOffAmount}
                                                                                    variant={'standard'}
                                                                                    value={roundOffAmount}
                                                                                    id={idNamingConversion('Round Off Amount', 'purchaseBill', 'TextField')}
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: clsx(classes.textFieldColor, classes.padding10L)
                                                                                        }
                                                                                    }}
                                                                                    inputProps={{
                                                                                        step: "any"
                                                                                    }}
                                                                                    InputLabelProps={{
                                                                                        className: classes.textFieldLableColorCustom
                                                                                    }}
                                                                                    disabled={roundOffMethod && !readDetails?.isViaNotification ? false : true}
                                                                                    onChange={(e) => { setRoundOffAmount(e.target.value); setTotal(parseFloat(parseFloat(totalInvoice + parseFloat(e?.target?.value || 0)).toFixed(2))); }}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Invoice Amount </Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(readDetails?.isViaNotification ? readDetails?.invoiceAmount : total)}</Typography>
                                                                    </Col>
                                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                        <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <Row gutter={20}>
                                                                            <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_CASH_DISCOUNT}
                                                                                    heads={HEADS_CODE}
                                                                                    details={cashDiscountOptions}
                                                                                    id={idNamingConversion('Cash Discount', 'customerProfile', 'DropDown')}
                                                                                    parentValue={customObject(cashDiscountOptions, cashDiscountId)}
                                                                                    onChange={stableCashDiscountChange}
                                                                                    position={"top"}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                            </Col>
                                                                            <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Amount</Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(cashDiscountAmount || 0)}</Typography>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Amount </Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(excisesAmount || 0)}</Typography>
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Assessable Value </Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(assessableValue || 0)}</Typography>
                                                                    </Col>
                                                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                        <Row>
                                                                            <Col xxl={6} xl={6} lg={10} md={10} sm={6} xs={6}>
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_TAX_CODE}
                                                                                    heads={HEADS_CODE}
                                                                                    details={taxCodedetails}
                                                                                    id={idNamingConversion('Tax Code', 'salesBill', 'DropDown')}
                                                                                    parentValue={customObject(taxCodedetails, taxCodeId)}
                                                                                    onChange={stableTaxCodeChange}
                                                                                    position={"bottom"}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                            </Col>
                                                                            <Col xxl={18} xl={18} lg={14} md={14} sm={18} xs={18}>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax</Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(tax || 0)}</Typography>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                                                                        <Row gutter={20}>
                                                                            <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_TCS}
                                                                                    heads={HEADS_NAME}
                                                                                    details={tcsOptions}
                                                                                    id={idNamingConversion('TCS', 'salesBill', 'DropDown')}
                                                                                    parentValue={customObject(tcsOptions, tcsNameId)}
                                                                                    onChange={stableTcsChange}
                                                                                    position={"bottom"}
                                                                                    disabled={!supplierDetail?.tcsBoolean}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                            </Col>
                                                                            <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>TCS</Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(tcs || 0)}</Typography>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </TabPanel>
                                                    <TabPanel value={"headerView"}>
                                                        <Row gutter={50} className={classes.mobileViewSalesState}>
                                                            <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                                                                <Row gutter={50}>
                                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <Row>
                                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Self Bill Number</Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{serialNumber ? serialNumber : '---'} </Typography>
                                                                            </Col>
                                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={classes.textAlignRight}>
                                                                                <span className={clsx(classes.statusButton, classes.margin20t, { [classes.confirmedButton]: viewStatus === 'CONFIRMED' },
                                                                                    { [classes.reversedButton]: viewStatus === 'REVERSED' }, { [classes.cancelledButton]: viewStatus === 'CANCELLED' })}>{capitalizeFirstLetter(viewStatus)}</span>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <FormControlLabel
                                                                            classes={{
                                                                                label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                                                            }}
                                                                            control={<Switch size='small'
                                                                                className={clsx(classes.customSwitch)}
                                                                                onChange={(e) => { setInAppTransition(!inAppTransition); }}
                                                                            />}
                                                                            id={idNamingConversion('In-AppTransactions', 'purchaseBill', 'Radio')}
                                                                            label="In-AppTransactions"
                                                                            labelPlacement="top"
                                                                            checked={inAppTransition}
                                                                            disabled={inAppStatus === 'ACCEPTED' ? false : true}
                                                                            className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <FormControlLabel
                                                                            classes={{
                                                                                label: clsx(classes.fonSize13)
                                                                            }}
                                                                            control={<Switch size='small'
                                                                                className={clsx(classes.customSwitch)}
                                                                                onChange={(e) => setPriceIncludesTax(!priceIncludesTax)}
                                                                                checked={priceIncludesTax || false}
                                                                            />}
                                                                            id={idNamingConversion('Price Includes Tax', 'purchaseBill', 'Radio')}
                                                                            label="Price Includes Tax"
                                                                            labelPlacement="top"
                                                                            disabled={lines?.length > 0 ? true : false}
                                                                            className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} >
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Supplier Name </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.name}</Typography>
                                                                            </> : <AutoCompleteComponent
                                                                                name={supplierNameLabel}
                                                                                heads={SUPPLIER_HEADS}
                                                                                details={supplierDetails}
                                                                                id={idNamingConversion('Supplier Name', 'purchaseBill', 'DropDown')}
                                                                                parentValue={customObject(supplierDetails, supplierId)}
                                                                                onChange={stableChangeSupplier}
                                                                                searchType={stableSupplierApi}
                                                                                parentError={errorSupplierId}
                                                                                position={"bottom"}
                                                                                customClasses={classes.margin20t}
                                                                            />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <InputLabel className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Supplier ID</InputLabel>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{supplierSerialNumber ? supplierSerialNumber : '---'}</Typography>
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status </Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter(viewStatus)}</Typography>

                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                <DesktopDatePicker
                                                                                    fullWidth
                                                                                    slots={{
                                                                                        openPickerIcon: DateIcon
                                                                                    }}
                                                                                    views={['year', 'month', 'day']}
                                                                                    //value={transactionDate}
                                                                                    label="Transaction Date"
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor,
                                                                                        }
                                                                                    }}
                                                                                    // minDate={new Date(y, m, 1)}
                                                                                    // maxDate={new Date(y, m + 1, 0)}
                                                                                    // readOnly={true}
                                                                                    format="dd/MM/yyyy"
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            id: idNamingConversion('Transaction Date', 'purchaseBill', 'TextField'),
                                                                                            autoComplete: 'one-time-code',
                                                                                            disabled: true,
                                                                                            value: transactionDate || null
                                                                                        },
                                                                                    }}
                                                                                    // onChange={(newValue) => {
                                                                                    //     (newValue === null || newValue == 'Invalid Date') ? setTransactionDate(new Date()) : setTransactionDate(newValue)
                                                                                    // }}
                                                                                    onChange={(newValue, newError) => {
                                                                                        setDateChange(newValue);
                                                                                        // if (newError?.validationError) {
                                                                                        //     setTransactionDate(new Date())
                                                                                        // } else {
                                                                                        //     setTransactionDate(newValue)
                                                                                        // }
                                                                                    }}
                                                                                />
                                                                            </LocalizationProvider>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Invoice Date </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{moment(readDetails.invoiceDate).format('DD MMM YYYY')}</Typography>
                                                                            </> :
                                                                                <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                        <DesktopDatePicker
                                                                                            fullWidth
                                                                                            slots={{
                                                                                                openPickerIcon: DateIcon
                                                                                            }}
                                                                                            views={['year', 'month', 'day']}
                                                                                            value={invoiceDate}
                                                                                            //minDate={transactionDate}
                                                                                            //maxDate={new Date(y, m + 1, 0)}
                                                                                            label="Invoice Date"
                                                                                            InputProps={{
                                                                                                classes: {
                                                                                                    input: classes.textFieldColor,
                                                                                                }
                                                                                            }}
                                                                                            slotProps={{
                                                                                                textField: {
                                                                                                    id: idNamingConversion('Invoice Date', 'purchaseBill', 'TextField'),
                                                                                                    autoComplete: 'one-time-code'
                                                                                                },
                                                                                            }}
                                                                                            //readOnly={true}
                                                                                            format="dd/MM/yyyy"
                                                                                            // onChange={(newValue) => {
                                                                                            //     (newValue === null || newValue == 'Invalid Date') ? setInvoiceDate(new Date()) : setInvoiceDate(newValue)
                                                                                            // }}
                                                                                            onChange={(newValue, newError) => {
                                                                                                if (newError?.validationError || newValue === null) {
                                                                                                    setInvoiceDate(new Date())
                                                                                                } else {
                                                                                                    setInvoiceDate(newValue)
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </LocalizationProvider>
                                                                                </div>
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Phone Number </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.phone}</Typography>
                                                                            </> :
                                                                                <TextField autoComplete='one-time-code'
                                                                                    label={["Phone Number ", <span key={"Phone Number"} className={classes.colorRedRequired}> *</span>]}
                                                                                    fullWidth
                                                                                    // type="number"
                                                                                    className={clsx(classes.margin20t)}
                                                                                    variant={'standard'}
                                                                                    error={errorMobile && true}
                                                                                    helperText={errorMobile}
                                                                                    value={mobile}
                                                                                    id={idNamingConversion('Phone Number', 'purchaseBill', 'TextField')}
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor
                                                                                        }
                                                                                    }}
                                                                                    InputLabelProps={{
                                                                                        className: classes.textFieldLableColorCustom
                                                                                    }}
                                                                                    onChange={(e) => setMobile(e.target.value)}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Method Of Payment </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.mop ? readDetails.mop.method : '---'}</Typography>
                                                                            </> :
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_MOP}
                                                                                    heads={MOP_HEADS}
                                                                                    details={mopDetails}
                                                                                    id={idNamingConversion('Method of Payment (MOP)', 'purchaseBill', 'DropDown')}
                                                                                    parentValue={customObject(mopDetails, mopId)}
                                                                                    onChange={stableMopChange}
                                                                                    position={"bottom"}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Currency </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.currency ? readDetails.currency.name : '---'}</Typography>
                                                                            </> :
                                                                                <AutoCompleteComponent
                                                                                    name={currencyNameLabel}
                                                                                    heads={CURRENCY_HEADS}
                                                                                    details={currencyDetails}
                                                                                    id={idNamingConversion('Currency', 'purchaseBill', 'DropDown')}
                                                                                    parentValue={customObject(currencyDetails, currencyId)}
                                                                                    onChange={stableCurrencyChange}
                                                                                    parentError={errorCurrency}
                                                                                    position={"top"}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Email </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.email ? readDetails.email : '---'}</Typography>
                                                                            </> :
                                                                                <TextField autoComplete='one-time-code'
                                                                                    label={'Email'}
                                                                                    fullWidth
                                                                                    className={clsx(classes.margin20t)}
                                                                                    variant={'standard'}
                                                                                    error={errorEmail && true}
                                                                                    helperText={errorEmail}
                                                                                    value={email}
                                                                                    id={idNamingConversion('Email', 'purchaseBill', 'TextField')}
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor
                                                                                        }
                                                                                    }}
                                                                                    InputLabelProps={{
                                                                                        className: classes.textFieldLableColorCustom,
                                                                                    }}
                                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Supplier Ref Number</Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.supplierRefNum || '---'}</Typography>
                                                                            </> :
                                                                                <TextField autoComplete='one-time-code'
                                                                                    label={inAppTransition ? "Supplier Ref Number" : ["Supplier Ref Number ", <span key={"Supplier Ref Number"} className={classes.colorRedRequired}> *</span>]}
                                                                                    fullWidth
                                                                                    className={clsx(classes.margin20t)}
                                                                                    variant={'standard'}
                                                                                    error={errorSupplierRefNum && true}
                                                                                    helperText={errorSupplierRefNum}
                                                                                    value={supplierRefNum}
                                                                                    id={idNamingConversion('Supplier Ref Number', 'purchaseBill', 'TextField')}
                                                                                    placeholder={"Enter Supplier Invoice number"}
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor
                                                                                        }
                                                                                    }}
                                                                                    inputProps={{ maxLength: 30 }}
                                                                                    InputLabelProps={{
                                                                                        className: classes.textFieldLableColorCustom,
                                                                                    }}
                                                                                    disabled={inAppTransition}
                                                                                    onChange={(e) => setSupplierRefNum(e.target.value)}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <TextField autoComplete='one-time-code'
                                                                            label={'Dispatch Details'}
                                                                            fullWidth
                                                                            className={clsx(classes.margin20t)}
                                                                            variant={'standard'}
                                                                            value={dispatchDetails || ''}
                                                                            id={idNamingConversion('Dispatch Details', 'purchaseBill', 'TextField')}
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor
                                                                                }
                                                                            }}
                                                                            inputProps={{ maxlength: 50 }}
                                                                            InputLabelProps={{
                                                                                className: classes.textFieldLableColorCustom,
                                                                            }}
                                                                            onChange={(e) => setDispatchDetails(e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <TextField autoComplete='one-time-code'
                                                                            label=''
                                                                            placeholder='Comments'
                                                                            value={comments || ''}
                                                                            variant={'outlined'}
                                                                            className={clsx(classes.margin20t, classes.customDescription)}
                                                                            fullWidth
                                                                            multiline
                                                                            rows={2}
                                                                            id={idNamingConversion('Comments', 'purchaseBill', 'TextField')}
                                                                            inputProps={{ maxlength: 120 }}
                                                                            name={"comments"}
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,
                                                                                }
                                                                            }}
                                                                            InputLabelProps={{
                                                                                className: classes.textFieldLableColorCustom,
                                                                            }}
                                                                            onChange={(e) => setComments(e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.margin35t, classes.bold)}>GST Details</Typography>
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <FormControlLabel
                                                                            classes={{
                                                                                label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                                                            }}
                                                                            control={<Switch size='small'
                                                                                className={clsx(classes.customSwitch)}
                                                                                onChange={(e) => handleIncludeGst(!includeGst)}
                                                                                checked={includeGst}
                                                                            />}
                                                                            id={idNamingConversion('Tax Invoice', 'purchaseBill', 'Radio')}
                                                                            label="Tax Invoice"
                                                                            labelPlacement="top"
                                                                            checked={includeGst}
                                                                            disabled={includeDisabled}
                                                                            className={clsx(classes.margin20t, classes.marginLeft0, classes.flexStart)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <AutoCompleteComponent
                                                                            name={NAME_PARTY_GST}
                                                                            heads={PARTY_GST_HEADS}
                                                                            details={partyGstdetails}
                                                                            id={idNamingConversion('Party GST Code', 'purchaseBill', 'DropDown')}
                                                                            parentValue={customObject(partyGstdetails, gstCodeId)}
                                                                            onChange={stableGstCodeChange}
                                                                            parentError={errorGstCode}
                                                                            position={"top"}
                                                                            customClasses={classes.margin20t}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                        <div className={clsx(classes.margin20t, classes.dateAdjust, classes.closeBackGround)}>
                                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                <DesktopDatePicker
                                                                                    fullWidth
                                                                                    slots={{
                                                                                        openPickerIcon: DateIcon
                                                                                    }}
                                                                                    views={['year', 'month', 'day']}
                                                                                    minDate={new Date(invoiceDate)}
                                                                                    allowKeyboardControl={false}
                                                                                    value={dueDate}
                                                                                    label="Due Date"
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor,
                                                                                        },
                                                                                        inputProps: { value: moment(dueDate).format('DD/MM/YYYY'), readOnly: false }
                                                                                    }}
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            error: errorDueDate ? true : false,
                                                                                            helperText: errorDueDate,
                                                                                            id: idNamingConversion('Due Date', 'purchaseBill', 'TextField'),
                                                                                            autoComplete: 'one-time-code'
                                                                                        },
                                                                                    }}
                                                                                    format="dd/MM/yyyy"
                                                                                    // onChange={(newValue) => {
                                                                                    //     (newValue === null || newValue == 'Invalid Date') ? setDueDate(new Date()) : setDueDate(newValue)
                                                                                    // }}
                                                                                    onChange={(newValue, newError) => {
                                                                                        if (newError?.validationError || newValue === null) {
                                                                                            setDueDate(new Date());
                                                                                        } else {
                                                                                            setDueDate(newValue);
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </LocalizationProvider>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
                                                                <Row gutter={50} className={clsx(classes.mobileAddressSalesEdit)}>
                                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                        <Typography variant={'h6'} style={{ height: 40 }} className={clsx(classes.typographyHeader, classes.typographyHeaderToolTip, classes.bold)}><span>Address</span>
                                                                            <Tooltip
                                                                                classes={{ popper: classes.customToolTip }}
                                                                                title={'The Address selected here will determine the Tax Applicable'} arrow placement="top" className={classes.tooltip}>
                                                                                <IconButton>
                                                                                    <Image src={infoMarkIcon} preview={false} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </Typography>
                                                                    </Col>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>State </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.state ? readDetails.state.name : '---'}</Typography>
                                                                            </> :
                                                                                <AutoCompleteComponent
                                                                                    name={stateNameLabel}
                                                                                    heads={STATE_HEADS}
                                                                                    details={stateDetails}
                                                                                    id={idNamingConversion('State', 'purchaseBill', 'DropDown')}
                                                                                    parentValue={customObject(stateDetails, stateId)}
                                                                                    onChange={stableStateChange}
                                                                                    position={"bottom"}
                                                                                    customClasses={classes.margin10t}
                                                                                    parentError={errorState}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Country </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.country ? readDetails.country.name : ''}</Typography>
                                                                            </> :
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_COUNTRY}
                                                                                    heads={COUNTRY_HEADS}
                                                                                    details={countryDetails}
                                                                                    id={idNamingConversion('Country', 'purchaseBill', 'DropDown')}
                                                                                    parentValue={customObject(countryDetails, countryId)}
                                                                                    onChange={stableCountryChange}
                                                                                    position={"top"}
                                                                                    customClasses={classes.margin10t}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>PinCode </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.pincode ? readDetails.pincode.code : '---'}</Typography>
                                                                            </> :
                                                                                <AutoCompleteComponent
                                                                                    name={pincodeNameLabel}
                                                                                    heads={PINCODE_HEADS}
                                                                                    details={pincodeDetails}
                                                                                    id={idNamingConversion('Pincode', 'purchaseBill', 'DropDown')}
                                                                                    parentValue={customObject(pincodeDetails, pincodeId)}
                                                                                    onChange={stablePincodeChange}
                                                                                    position={"bottom"}
                                                                                    customClasses={classes.margin20t}
                                                                                    parentError={errorPincode}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Dist/City/Town</Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.city ? readDetails.city.name : '---'}</Typography>
                                                                            </> :
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_CITY}
                                                                                    heads={CITY_HEADS}
                                                                                    details={cityDetails}
                                                                                    id={idNamingConversion('City', 'purchaseBill', 'DropDown')}
                                                                                    parentValue={customObject(cityDetails, cityId)}
                                                                                    onChange={stableCityChange}
                                                                                    position={"bottom"}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                        {
                                                                            readDetails.isViaNotification ? <>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Area </Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.area ? readDetails.area.name : '---'}</Typography>
                                                                            </> :
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_AREA}
                                                                                    heads={AREA_HEADS}
                                                                                    details={areaDetails}
                                                                                    parentValue={customObject(areaDetails, areaId)}
                                                                                    onChange={stableAreaChange}
                                                                                    position={"top"}
                                                                                    id={idNamingConversion('Area', 'purchaseBill', 'DropDown')}
                                                                                    customClasses={classes.margin20t}
                                                                                    customLink={'/admin/address/area'}
                                                                                    linkText={'Go to Area'}
                                                                                    infoMark={'Select the local postal area from the list or Goto Area master to create a new record for the missing area info. The field is optional and will take blank values.'}
                                                                                />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                        <TextField autoComplete='one-time-code'
                                                                            label=''
                                                                            placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                                                            value={address}
                                                                            variant={'outlined'}
                                                                            className={clsx(classes.margin60t, classes.customDescription)}
                                                                            fullWidth
                                                                            multiline
                                                                            rows={4}
                                                                            id={idNamingConversion('Address', 'purchaseBill', 'DropDown')}
                                                                            name={"address"}
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,
                                                                                }
                                                                            }}
                                                                            InputLabelProps={{
                                                                                className: classes.textFieldLableColorCustom,
                                                                            }}
                                                                            onChange={(e) => setAddress(e.target.value)}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={50}>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Totals</Typography>
                                                            </Col>
                                                            {parameterDetails?.purchaseValue &&
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Purchase Total</Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹  {currencyFormat(lines.length > 0 ? lines?.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.purchaseValue || 0), 0) : 0)}</Typography>
                                                                </Col>
                                                            }
                                                        </Row>
                                                        <Row gutter={50}>
                                                            <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                                                                <Row gutter={50}>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Discount</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹  {currencyFormat(totalDiscount)}</Typography>
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Net Amount</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(netAmount)}</Typography>
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                                            <span>GST Amount </span>
                                                                            <Tooltip
                                                                                classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                                                title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                                                <IconButton>
                                                                                    <Image src={infoMarkIcon} preview={false} />
                                                                                </IconButton>
                                                                            </Tooltip></Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(gstAmount)}</Typography>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={16} sm={24} xs={24}>
                                                                <Row gutter={50}>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={8} xs={24}>
                                                                        <Row>
                                                                            <Col xxl={8} xl={10} lg={10} md={8} sm={6} xs={6}>
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_ROUND_OFF}
                                                                                    heads={HEADS_NAME}
                                                                                    details={ROUNDOFF_OPTIONS}
                                                                                    parentValue={customObject(ROUNDOFF_OPTIONS, roundOffMethod)}
                                                                                    onChange={stableRoundOff}
                                                                                    position={"bottom"}
                                                                                    id={idNamingConversion('Round off', 'purchaseBill', 'DropDown')}
                                                                                    disabled={readDetails?.isViaNotification ? true : false}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                            </Col>
                                                                            <Col xxl={16} xl={14} lg={14} md={16} sm={18} xs={18}>
                                                                                <TextField autoComplete='one-time-code'
                                                                                    label={[""]}
                                                                                    fullWidth
                                                                                    type="number"
                                                                                    id={idNamingConversion('Round Off Amount', 'purchaseBill', 'TextField')}
                                                                                    className={clsx(classes.margin20t)}
                                                                                    error={errorRoundOffAmount && true}
                                                                                    helperText={errorRoundOffAmount}
                                                                                    variant={'standard'}
                                                                                    value={roundOffAmount}
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: clsx(classes.textFieldColor, classes.padding10L)
                                                                                        }
                                                                                    }}
                                                                                    inputProps={{
                                                                                        step: "any"
                                                                                    }}
                                                                                    InputLabelProps={{
                                                                                        className: classes.textFieldLableColorCustom
                                                                                    }}
                                                                                    disabled={roundOffMethod && !readDetails?.isViaNotification ? false : true}
                                                                                    onChange={(e) => { setRoundOffAmount(e.target.value); setTotal(parseFloat(parseFloat(totalInvoice + parseFloat(e?.target?.value || 0)).toFixed(2))); }}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={16} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Invoice Amount </Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(readDetails?.isViaNotification ? readDetails?.invoiceAmount : total)}</Typography>
                                                                    </Col>
                                                                </Row>
                                                            </Col>

                                                        </Row>
                                                        <Row gutter={50}>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={50}>
                                                            <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                                                                <Row gutter={50}>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                        <Row gutter={20}>
                                                                            <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_CASH_DISCOUNT}
                                                                                    heads={HEADS_CODE}
                                                                                    details={cashDiscountOptions}
                                                                                    id={idNamingConversion('Cash Discount', 'customerProfile', 'DropDown')}
                                                                                    parentValue={customObject(cashDiscountOptions, cashDiscountId)}
                                                                                    onChange={stableCashDiscountChange}
                                                                                    position={"top"}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                            </Col>
                                                                            <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Amount</Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(cashDiscountAmount || 0)}</Typography>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Amount </Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(excisesAmount || 0)}</Typography>
                                                                    </Col>
                                                                    <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Assessable Value </Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(assessableValue || 0)}</Typography>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={16} sm={24} xs={24}>
                                                                <Row gutter={50}>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={8} xs={24}>
                                                                        <Row gutter={20}>
                                                                            <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_TAX_CODE}
                                                                                    heads={HEADS_CODE}
                                                                                    details={taxCodedetails}
                                                                                    id={idNamingConversion('Tax Code', 'salesBill', 'DropDown')}
                                                                                    parentValue={customObject(taxCodedetails, taxCodeId)}
                                                                                    onChange={stableTaxCodeChange}
                                                                                    position={"bottom"}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                            </Col>
                                                                            <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax</Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(tax || 0)}</Typography>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={8} xs={24}>
                                                                        <Row gutter={20}>
                                                                            <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                                <AutoCompleteComponent
                                                                                    name={NAME_TCS}
                                                                                    heads={HEADS_NAME}
                                                                                    details={tcsOptions}
                                                                                    id={idNamingConversion('TCS', 'salesBill', 'DropDown')}
                                                                                    parentValue={customObject(tcsOptions, tcsNameId)}
                                                                                    onChange={stableTcsChange}
                                                                                    position={"bottom"}
                                                                                    disabled={!supplierDetail?.tcsBoolean}
                                                                                    customClasses={classes.margin20t}
                                                                                />
                                                                            </Col>
                                                                            <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>TCS</Typography>
                                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(tcs || 0)}</Typography>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </TabPanel>
                                                </TabContext>
                                            </div>
                                        </Box>
                                    )
                                }
                                {
                                    readLoader === true && (
                                        <div style={{ textAlign: "center" }}>
                                            <div className={classes.loadMoreCircle}></div>
                                        </div>
                                    )
                                }
                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Self Bill Lines'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        ref={childRef}
                        component={
                            <>
                                {
                                    !readDetails.isViaNotification && <Row>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.textAlignRight}>
                                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                                {
                                                    roleManagement !== '' && checkComponentPermission('Supply Self Bill', 'Page', 'Add Products') && supplierId &&
                                                    <NavLink to={'#'} id={idNamingConversion('Add Products', 'purchaseBill', 'Link')} onClick={() => setProductsVisible(true)} className={clsx(classes.customLink, classes.disInline)}>
                                                        <Image
                                                            src={AddIcon}
                                                            preview={false}
                                                            className={clsx(classes.antImage)}
                                                        /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Products</span>
                                                    </NavLink>
                                                }
                                                {
                                                    supplierId && <NavLink to="#" id={idNamingConversion('Add Lines', 'purchaseBill', 'Link')} onClick={() => handleOpen()} className={clsx(classes.customLink, classes.disInline)}>
                                                        <Image
                                                            src={AddIcon}
                                                            preview={false}
                                                            className={clsx(classes.antImage)}
                                                        />  <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Lines</span>
                                                    </NavLink>
                                                }
                                            </Space>
                                        </Col>
                                    </Row>
                                }
                                <div className={clsx(classes.tableRoot)}>
                                    <CustomInfiniteScroll
                                        loadMore={true}
                                        loadMoreContent={false}
                                        heads={billLineHead}
                                        width={true}
                                        component={
                                            <>
                                                {
                                                    showDetails === false && lines && lines.length > 0 && lines.map((data, i) => (
                                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                            <TableCell style={{ width: getColumnWidth(billLineHead, 0) }}><span style={{ width: getColumnWidth(billLineHead, 0) }}>{i + 1}</span></TableCell>
                                                            <TableCell style={{ width: getColumnWidth(billLineHead, 1) }}><NavLink style={{ width: getColumnWidth(billLineHead, 1) }} to={"#"} className={clsx(classes.bold, classes.color)} onClick={() => onView(data, i)}><span className={classes.descEllipsis}>{data.description}</span></NavLink></TableCell>
                                                            <TableCell style={{ width: getColumnWidth(billLineHead, 2) }}><span style={{ width: getColumnWidth(billLineHead, 2) }}>{data.quantity ? data.quantity : '---'}</span></TableCell>
                                                            <TableCell style={{ width: getColumnWidth(billLineHead, 3) }}>
                                                                <span style={{ width: getColumnWidth(billLineHead, 4) }}> {
                                                                    unitMesurementdetails && unitMesurementdetails.length > 0 && unitMesurementdetails.filter(unitMesurementdetail => unitMesurementdetail.id === data.unitId).map(filteredUnit => (
                                                                        <React.Fragment key={filteredUnit.id}>
                                                                            {filteredUnit.name}
                                                                        </React.Fragment>
                                                                    ))
                                                                }</span>
                                                            </TableCell>
                                                            <TableCell style={{ width: getColumnWidth(billLineHead, 5) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(billLineHead, 5) }}>{`₹ ${currencyFormat(data?.pricePerUnit || 0)}`}</span></TableCell>
                                                            <TableCell style={{ width: getColumnWidth(billLineHead, 6) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(billLineHead, 6) }}>
                                                                {`₹ ${(data.discountAmount || data.discountPercent) ?
                                                                    (data.quantity < 0 ?
                                                                        currencyFormat((parseFloat(data?.discountAmount || 0) - parseFloat(((data.quantity * data.pricePerUnit) * (data?.discountPercent || 0)) / 100))) :
                                                                        currencyFormat((parseFloat(data?.discountAmount || 0) + parseFloat(((data.quantity * data.pricePerUnit) * (data?.discountPercent || 0)) / 100))))
                                                                    : currencyFormat(0)}`}
                                                            </span></TableCell>
                                                            <TableCell style={{ width: getColumnWidth(billLineHead, 7) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(billLineHead, 7) }}>{`₹ ${currencyFormat(data?.amount || 0)}`}</span></TableCell>
                                                            <TableCell style={{ width: getColumnWidth(billLineHead, 8) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(billLineHead, 8) }}>{`₹ ${currencyFormat(data?.excisesTotal || 0)}`}</span></TableCell>
                                                            <TableCell style={{ width: getColumnWidth(billLineHead, 8) }}><span style={{ width: getColumnWidth(billLineHead, 8) }}>{data.productGstId ? (
                                                                productGstdetails && productGstdetails.length > 0 && productGstdetails.filter(productGstdetail => productGstdetail.id === data.productGstId).map(filteredGst => (
                                                                    <React.Fragment key={filteredGst.id}>
                                                                        {filteredGst.code}
                                                                    </React.Fragment>
                                                                )))
                                                                : '---'}</span></TableCell>
                                                            <TableCell style={{ width: getColumnWidth(billLineHead, 9) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(billLineHead, 9) }}>₹ {data.gstAmount ? currencyFormat(data.gstAmount) : '0.00'}</span></TableCell>
                                                            <TableCell className={classes.textAlignRight}>
                                                                <Space size={[0, 0]} className={clsx(classes.iconPadding)}>
                                                                    <NavLink to={"#"} onClick={() => onView(data, i)}>
                                                                        <Image
                                                                            src={ViewIcon}
                                                                            preview={false}
                                                                        />
                                                                    </NavLink>
                                                                    {
                                                                        !readDetails.isViaNotification && <NavLink to={"#"} onClick={() => onEdit(data, i)}>
                                                                            <Image
                                                                                src={EditIcon}
                                                                                preview={false}
                                                                            />
                                                                        </NavLink>
                                                                    }
                                                                    <NavLink to={"#"} onClick={() => onDelete(data, i)}>
                                                                        <Image
                                                                            src={DeleteIcon}
                                                                            preview={false}
                                                                        />
                                                                    </NavLink>
                                                                </Space>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                {
                                                    showDetails === false && lines && lines.length === 0 && (
                                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell style={{ textAlign: "center" }} colSpan={10}>
                                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your Bill'}</p>

                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                                {
                                                    showDetails === true && (
                                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell style={{ textAlign: "center" }} colSpan={10}><div className={classes.loadMoreCircle}></div></TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            </>
                                        }
                                    />
                                </div>
                            </>
                        }
                        lastContent={true}
                    />
                </div>
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                width={'690px'}
                title={primaryTitle + ' Purchase Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete='off'
                        onSubmit={(e) => handleLineSubmit(e)}>
                        <div className={classes.customFormFlex}>
                            <Row gutter={30}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Line {lineNumber} Details</Typography>
                                    <FormControl
                                        style={{ position: "absolute", right: 10, top: 0, alignItems: "end" }}
                                        className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                        variant={'standard'}
                                        fullWidth>
                                        <RadioGroup
                                            row
                                            value={showNameDesc}
                                            onChange={(e) => {
                                                storageSetItem('billProductView', e.target.value);
                                                setShowNameDesc(e.target.value);
                                            }}>
                                            <FormControlLabel value="name" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Name" />
                                            <FormControlLabel value="description" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Description" />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <AutoCompleteComponent

                                        name={`Product (Optional) ${lineProduct ? (
                                            myProductdetails && myProductdetails.length > 0
                                                ? '- ' + myProductdetails.find(mP => mP.id === lineProduct)?.productId ?? "---"
                                                : "---"
                                        ) : "---"}`}
                                        heads={productHeads}
                                        details={myProductdetails}
                                        id={idNamingConversion("Product", "purchaseBillLine", "DropDown")}
                                        parentValue={customObject(myProductdetails, lineProduct)}
                                        onChange={stableHandleProductChange}
                                        onChangeText={stableHandleProductTextChange}
                                        position="bottom"
                                        searchType={stableProductApi}
                                        customClasses={classes.margin10t}
                                    />
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <InputLabel error={errorLineDescription ? true : false} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description <span key={"Description"} className={classes.colorRedRequired}> *</span></InputLabel>
                                    <TextField autoComplete='one-time-code'
                                        maxRows={2}
                                        fullWidth
                                        className={clsx(classes.textAreaAdjust)}
                                        multiline={true}
                                        value={lineDescription}
                                        error={errorLineDescription ? true : false}
                                        helperText={errorLineDescription}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        id={idNamingConversion('Description', 'purchaseBillLine', 'TextField')}
                                        InputLabelProps={{
                                            className: classes.textAreaLableColorCustom,
                                        }}
                                        onChange={(e) => { setLineDescription(e.target.value) }}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                        label={["Quantity ", <span key={"Quantity"} className={classes.colorRedRequired}> *</span>]}
                                        type={'number'}
                                        variant={'standard'}
                                        value={lineQuantity}
                                        onWheel={(e) => e.target.blur()}
                                        error={errorLineQuantity ? true : false}
                                        helperText={errorLineQuantity}
                                        fullWidth
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }, step: "any"
                                        }}
                                        id={idNamingConversion('Quantity', 'purchaseBillLine', 'TextField')}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        disabled={selectedBatchId?.length ? true : false}
                                        inputProps={{
                                            step: "any"
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value !== '') {
                                                if (!debitNote && e.target.value < 0) {
                                                    setLineQuantity(e.target.value = 0)
                                                } else if (debitNote && e.target.value >= 0) {
                                                    setLineQuantity(-(e.target.value))
                                                } else {
                                                    setLineQuantity(e.target.value)
                                                }
                                                handleStockUnits(lineProduct, lineUnitId, Math.abs(e.target.value));
                                            } else {
                                                setLineQuantity(e.target.value)
                                            }
                                        }}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <AutoCompleteComponent
                                        name={unitNameLabel}
                                        heads={UNIT_HEADS}
                                        details={unitOptions}
                                        parentValue={customObject(unitOptions, lineUnitId)}
                                        onChange={stableLineUnitChange}
                                        position={"bottom"}
                                        id={idNamingConversion('Unit', 'purchaseBillLine', 'DropDown')}
                                        customClasses={classes.margin20t}
                                        parentError={errorLineUnitId}
                                        infoMark={lineStock?.unitId !== lineUnitId ? `${lineStock?.quantity} - ${lineStock?.unit?.name} ` : false}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <div className={clsx(classes.customUnitPrice, classes.purchaseCustomUnitPrice)}>
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={["Unit Price ", <span key={"Unit Price"} className={classes.colorRedRequired}> *</span>]}
                                            type={'number'}
                                            variant={'standard'}
                                            placeholder={productPrices && productPrices[customObject(unitMesurementdetails, lineUnitId)?.name]}
                                            error={errorLinePrice ? true : false}
                                            helperText={errorLinePrice}
                                            value={linePrice}
                                            fullWidth
                                            id={idNamingConversion('Unit Price', 'purchaseBillLine', 'TextField')}
                                            onWheel={(e) => e.target.blur()}
                                            InputProps={{
                                                startAdornment: <InputAdornment className={clsx(classes.textFieldColor)} position="start">₹ </InputAdornment>,
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                endAdornment: productPrices?.lastprice && !unitPriceList && lineProduct && linePrice &&
                                                    linePrice === productPrices?.lastprice[customObject(unitMesurementdetails, lineUnitId)?.name]?.price ?
                                                    <InputAdornment className={clsx(classes.lastSalesPrice)} position="end">
                                                        <div className={classes.infoSuggestion}><img alt={"Last Purchase Price"} src={InfoMark} /> <span>Last Purchase Price</span></div></InputAdornment>
                                                    : false,
                                            }}
                                            inputProps={{
                                                step: "any"
                                            }}
                                            onFocus={() => setUnitPriceFocusList(true)}
                                            //  onBlur={() => setUnitPriceList(false)}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLinePrice((e.target.value = 0)) : setLinePrice(e.target.value) : setLinePrice(e.target.value)}
                                        />
                                        {
                                            productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 && unitPriceFocusList && lineProduct && <div className={classes.suggestionBox}>

                                                <CloseIcon onClick={() => setUnitPriceFocusList(true)} className={classes.productpriceCloseIcon} />
                                                <div className={classes.suggestionBoxTitle}><div className={classes.infoSuggestion}><img alt={"Last Purchase Price"} src={InfoMark} /> <span>Last Purchase Price</span></div></div>
                                                <div className={classes.historicalData}>
                                                    {
                                                        productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 && Object?.entries(productPrices?.lastprice)?.map(([key, value]) => (
                                                            <NavLink to="#" onClick={() => handleProductPrice(key)} key={key}>₹ {value?.price} per {key}</NavLink>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                        label={["MRP "]}
                                        type={'number'}
                                        variant={'standard'}
                                        value={lineMrp}
                                        fullWidth
                                        onWheel={(e) => e.target.blur()}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            },
                                        }}
                                        id={idNamingConversion('MRP', 'purchaseBillLine', 'TextField')}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => e.target.value !== '' ? e.target.value < 1 ? setLineMrp((e.target.value = 1)) : setLineMrp(e.target.value) : setLineMrp(e.target.value)}
                                    />
                                    {/* <Col span={12}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')
                                                }}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    checked={linePriceIncludesTax}
                                                />}
                                                label="Price Includes Tax"
                                                labelPlacement="top"
                                                disabled={true}
                                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                            />
                                        </Col> */}
                                </Col>
                                {parameterDetails?.purchaseValue &&
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Purchase Value</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSalesValue ? '₹ ' + currencyFormat(lineSalesValue || 0) : '---'}</Typography>
                                    </Col>
                                }
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row align="bottom">
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Line Amount</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{'₹ ' + currencyFormat(lineAmount || 0)}</Typography>
                                        </Col>
                                        {
                                            lineBatchActivation && parameterDetails?.inventoryTransaction ?
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    <NavLink
                                                        to="#"
                                                        id={idNamingConversion('View Batch', 'purchaseBill', 'Link')}
                                                        onClick={() => setViewBatch(!viewBatch)}
                                                        className={clsx(classes.customLink, classes.textAlignRight)}>
                                                        <Image
                                                            src={ViewIcon}
                                                            preview={false}
                                                            className={clsx(classes.antImage, classes.padding10Left)}
                                                        /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>View Batch</span>
                                                    </NavLink>
                                                </Col> : ''
                                        }
                                    </Row>
                                </Col>
                                {
                                    viewBatch && lineBatchActivation && parameterDetails?.inventoryTransaction && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Row align="bottom">
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Batch Details</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Row>
                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <FormControlLabel
                                                            classes={{
                                                                label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                                            }}
                                                            control={<Switch size='small'
                                                                className={clsx(classes.customSwitch)}
                                                                onChange={(e) => { setBatchOverride(!batchOverride); }}
                                                            />}
                                                            id={idNamingConversion('Batch OverRide', 'purchaseBill', 'Radio')}
                                                            label="Batch OverRide"
                                                            labelPlacement="top"
                                                            checked={batchOverride}
                                                            disabled={batch?.length ? true : false}
                                                            className={clsx(classes.marginLeft0, classes.flexStart)}
                                                        />
                                                    </Col>
                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        {
                                                            !debitNote && <NavLink
                                                                to="#"
                                                                id={idNamingConversion('Add Batch', 'purchaseBill', 'Link')}
                                                                onClick={() => addBatch()}
                                                                className={clsx(classes.customLink, classes.textAlignRight)}>
                                                                <Image
                                                                    src={AddIcon}
                                                                    preview={false}
                                                                    className={clsx(classes.antImage, classes.padding10Left)}
                                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Batch</span>
                                                            </NavLink>
                                                        }
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <TableContainer className={clsx(classes.tablecontain, classes.tablecontainBatch)}>
                                                    {
                                                        debitNote ? <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell className={clsx(classes.tablealign)}>
                                                                        <Checkbox disabled={debitBatch} onChange={(e) => handleBulkClick(e.target.checked)} />
                                                                    </TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>Batch ID</TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>Qty</TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>MRP</TableCell>
                                                                    {
                                                                        parameterDetails?.purchaseBatchDiscount && <TableCell className={clsx(classes.tablealign)}>Disc.Amt</TableCell>
                                                                    }
                                                                    {
                                                                        parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.tablealign)}>Mfg Date</TableCell>}
                                                                    {
                                                                        parameterDetails?.batchExpiryDate && <TableCell className={clsx(classes.tablealign)}>Expiry Date</TableCell>}
                                                                    {
                                                                        parameterDetails?.batchBestBeforeDate && <TableCell className={clsx(classes.tablealign)}>Use By | Best Before</TableCell>}
                                                                </TableRow>
                                                            </TableHead>
                                                            {
                                                                batch?.length > 0 ? batch.map((data, i) => (
                                                                    <TableRow id={'tableRow_' + i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative)}>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell)}><Checkbox disabled={debitBatch} checked={isSelected(data.id)} onChange={(e) => handleClick(data.id)} /> </TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell)}>{data?.batchNumber || '---'}</TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.purchaseQuantity || '---'}</TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.mrp || '---'}</TableCell>
                                                                        {
                                                                            parameterDetails?.purchaseBatchDiscount && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.discountAmount || '---'}</TableCell>
                                                                        }
                                                                        {
                                                                            parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.manufacturingDate ? moment(data?.manufacturingDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                        {
                                                                            parameterDetails?.batchExpiryDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.expiryDate ? moment(data?.expiryDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                        {
                                                                            parameterDetails?.batchBestBeforeDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.useByDate ? moment(data?.useByDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                    </TableRow>
                                                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                    <TableCell className={classes.textAlignCenter} colSpan={5}>
                                                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Please add batch'}</p>
                                                                    </TableCell>
                                                                </TableRow>
                                                            }
                                                        </Table> : <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell className={clsx(classes.tablealign)}>Batch ID</TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>Qty</TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>MRP</TableCell>
                                                                    {
                                                                        parameterDetails?.purchaseBatchDiscount && <TableCell className={clsx(classes.tablealign, classes.textAlignLeft)}>Disc.Amt</TableCell>
                                                                    }
                                                                    {
                                                                        parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.tablealign, classes.textAlignLeft)}>Mfg Date</TableCell>
                                                                    }
                                                                    {
                                                                        parameterDetails?.batchExpiryDate && <TableCell className={clsx(classes.tablealign, classes.textAlignLeft)}>Expiry Date</TableCell>
                                                                    }
                                                                    {
                                                                        parameterDetails?.batchBestBeforeDate && <TableCell className={clsx(classes.tablealign, classes.textAlignLeft)}>Use By | Best Before</TableCell>
                                                                    }
                                                                    <TableCell className={clsx(classes.tablealign)}></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            {
                                                                batch?.length > 0 ? batch.map((data, i) => (
                                                                    <TableRow id={'tableRow_' + i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative)}>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                                                            <TextField autoComplete='one-time-code'
                                                                                fullWidth
                                                                                className={clsx(classes.batchTextField)}
                                                                                value={data?.batchNumber}
                                                                                InputProps={{
                                                                                    classes: {
                                                                                        input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                                                    }
                                                                                }}
                                                                                InputLabelProps={{
                                                                                    className: classes.textAreaLableColorCustom,
                                                                                }}
                                                                                inputProps={{
                                                                                    step: "any"
                                                                                }}
                                                                                id={idNamingConversion('Batch_Number_' + i, 'purchaseBill', 'TextField')}
                                                                                onWheel={(e) => e.target.blur()}
                                                                                onFocus={(e) => e.target.select()}
                                                                                onChange={(e) => changeHandlerBatch(data, e.target.value, 'batchNumber', i)}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                                                            <TextField autoComplete='one-time-code'
                                                                                fullWidth
                                                                                className={clsx(classes.batchTextField)}
                                                                                value={data?.purchaseQuantity || ''}
                                                                                type={'number'}
                                                                                InputProps={{
                                                                                    classes: {
                                                                                        input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                                                    }
                                                                                }}
                                                                                InputLabelProps={{
                                                                                    className: classes.textAreaLableColorCustom,
                                                                                }}
                                                                                inputProps={{
                                                                                    step: "any"
                                                                                }}
                                                                                id={idNamingConversion('Qty_' + i, 'purchaseBill', 'TextField')}
                                                                                onWheel={(e) => e.target.blur()}
                                                                                onFocus={(e) => e.target.select()}
                                                                                onChange={(e) => {
                                                                                    if (e.target.value !== '') {
                                                                                        if (!debitNote && e.target.value < 0) {
                                                                                            changeHandlerBatch(data, e.target.value = 0, 'purchaseQuantity', i)
                                                                                        } else if (debitNote && e.target.value >= 0) {
                                                                                            changeHandlerBatch(data, -(e.target.value), 'purchaseQuantity', i)
                                                                                        } else {
                                                                                            changeHandlerBatch(data, e.target.value, 'purchaseQuantity', i)
                                                                                        }
                                                                                    } else {
                                                                                        changeHandlerBatch(data, e.target.value, 'purchaseQuantity', i)
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                                                            <TextField autoComplete='one-time-code'
                                                                                fullWidth
                                                                                className={clsx(classes.batchTextField)}
                                                                                value={data?.mrp || ''}
                                                                                type={'number'}
                                                                                InputProps={{
                                                                                    classes: {
                                                                                        input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                                                    }
                                                                                }}
                                                                                InputLabelProps={{
                                                                                    className: classes.textAreaLableColorCustom,
                                                                                }}
                                                                                inputProps={{
                                                                                    step: "any"
                                                                                }}
                                                                                id={idNamingConversion('MRP_' + i, 'purchaseBill', 'TextField')}
                                                                                onWheel={(e) => e.target.blur()}
                                                                                onFocus={(e) => e.target.select()}
                                                                                onChange={(e) => changeHandlerBatch(data, e.target.value, 'mrp', i)}
                                                                            />
                                                                        </TableCell>
                                                                        {
                                                                            parameterDetails?.purchaseBatchDiscount && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                                                                <TextField autoComplete='one-time-code'
                                                                                    fullWidth
                                                                                    className={clsx(classes.batchTextField)}
                                                                                    value={data?.discountAmount || ''}
                                                                                    type={'number'}
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                                                        }
                                                                                    }}
                                                                                    InputLabelProps={{
                                                                                        className: classes.textAreaLableColorCustom,
                                                                                    }}
                                                                                    inputProps={{
                                                                                        step: "any"
                                                                                    }}
                                                                                    id={idNamingConversion('Discount_' + i, 'purchaseBill', 'TextField')}
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                    onFocus={(e) => e.target.select()}
                                                                                    onChange={(e) => {
                                                                                        if (e.target.value < 0) {
                                                                                            changeHandlerBatch(data, e.target.value = 0, 'discountAmount', i)
                                                                                        } else {
                                                                                            changeHandlerBatch(data, e.target.value, 'discountAmount', i)
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                        }
                                                                        {
                                                                            parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                                                                <div className={clsx(classes.dateAdjust, classes.dateAdjustBatch)} tabIndex={-1}>
                                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                        <DesktopDatePicker
                                                                                            fullWidth
                                                                                            slots={{
                                                                                                openPickerIcon: DateIcon
                                                                                            }}
                                                                                            views={['year', 'month', 'day']}
                                                                                            value={data?.manufacturingDate || ''}
                                                                                            label=""
                                                                                            InputProps={{
                                                                                                classes: {
                                                                                                    input: classes.textFieldColor,
                                                                                                }
                                                                                            }}
                                                                                            slotProps={{
                                                                                                textField: {
                                                                                                    id: idNamingConversion('Manufacturing Date_' + i, 'purchaseBill', 'TextField'),
                                                                                                    autoComplete: 'one-time-code'
                                                                                                },
                                                                                            }}
                                                                                            format="dd/MM/yyyy"
                                                                                            onChange={(newValue, newError) => {
                                                                                                if (newError?.validationError || newValue === null) {
                                                                                                    changeHandlerBatch(data, new Date(), 'manufacturingDate', i);
                                                                                                } else {
                                                                                                    changeHandlerBatch(data, newValue, 'manufacturingDate', i);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </LocalizationProvider>
                                                                                </div>
                                                                            </TableCell>
                                                                        }
                                                                        {
                                                                            parameterDetails?.batchExpiryDate &&
                                                                            <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                                                                <div className={clsx(classes.dateAdjust, classes.dateAdjustBatch)} tabIndex={-1}>
                                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                        <DesktopDatePicker
                                                                                            fullWidth
                                                                                            slots={{
                                                                                                openPickerIcon: DateIcon
                                                                                            }}
                                                                                            views={['year', 'month', 'day']}
                                                                                            value={data?.expiryDate || ''}
                                                                                            label=""
                                                                                            InputProps={{
                                                                                                classes: {
                                                                                                    input: classes.textFieldColor,
                                                                                                }
                                                                                            }}
                                                                                            slotProps={{
                                                                                                textField: {
                                                                                                    id: idNamingConversion('Expiry Date_' + i, 'purchaseBill', 'TextField'),
                                                                                                    autoComplete: 'one-time-code'
                                                                                                },
                                                                                            }}
                                                                                            format="dd/MM/yyyy"
                                                                                            onChange={(newValue, newError) => {
                                                                                                if (newError?.validationError || newValue === null) {
                                                                                                    changeHandlerBatch(data, new Date(), 'expiryDate', i);
                                                                                                } else {
                                                                                                    changeHandlerBatch(data, newValue, 'expiryDate', i);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </LocalizationProvider>
                                                                                </div>
                                                                            </TableCell>
                                                                        }
                                                                        {
                                                                            parameterDetails?.batchBestBeforeDate &&
                                                                            <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                                                                <div className={clsx(classes.dateAdjust, classes.dateAdjustBatch)} tabIndex={-1}>
                                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                        <DesktopDatePicker
                                                                                            fullWidth
                                                                                            slots={{
                                                                                                openPickerIcon: DateIcon
                                                                                            }}
                                                                                            views={['year', 'month', 'day']}
                                                                                            value={data?.useByDate || ''}
                                                                                            label=""
                                                                                            InputProps={{
                                                                                                classes: {
                                                                                                    input: classes.textFieldColor,
                                                                                                }
                                                                                            }}
                                                                                            slotProps={{
                                                                                                textField: {
                                                                                                    id: idNamingConversion('Use By Date_' + i, 'purchaseBill', 'TextField'),
                                                                                                    autoComplete: 'one-time-code'
                                                                                                },
                                                                                            }}
                                                                                            format="dd/MM/yyyy"
                                                                                            onChange={(newValue, newError) => {
                                                                                                if (newError?.validationError || newValue === null) {
                                                                                                    changeHandlerBatch(data, new Date(), 'useByDate', i);
                                                                                                } else {
                                                                                                    changeHandlerBatch(data, newValue, 'useByDate', i);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </LocalizationProvider>
                                                                                </div>
                                                                            </TableCell>
                                                                        }
                                                                        <TableCell style={{ padding: "5px 0 5px 5px" }} className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                                                            <NavLink id={idNamingConversion('Delete_' + data.id, 'purchaseBill', 'Icon')} to={"#"} onClick={() => onDeletBatch(data)}>
                                                                                <Image
                                                                                    src={DeleteIcon}
                                                                                    preview={false}
                                                                                />
                                                                            </NavLink>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                    <TableCell className={classes.textAlignCenter} colSpan={5}>
                                                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Please add batch'}</p>
                                                                    </TableCell>
                                                                </TableRow>
                                                            }
                                                            {
                                                                errorBatchQuantity && <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative)}>
                                                                    <TableCell className={classes.textAlignLeft} colSpan={5}><p style={{ color: "red" }}>{errorBatchQuantity}</p></TableCell>
                                                                </TableRow>
                                                            }
                                                        </Table>
                                                    }
                                                </TableContainer>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Discount Details</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                        label='Discount %'
                                        title={'Enter discount in Percentage'}
                                        variant={'standard'}
                                        type={'number'}
                                        value={lineDiscountPercentage}
                                        fullWidth
                                        onWheel={(e) => e.target.blur()}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        id={idNamingConversion('Discount%', 'purchaseBillLine', 'TextField')}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineDiscountPercentage((e.target.value = 0)) : setLineDiscountPercentage(e.target.value) : setLineDiscountPercentage(e.target.value)}

                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                        <span>Calculated discount amount</span>
                                        <Tooltip
                                            classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                            title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                            <IconButton>
                                                <Image src={infoMarkIcon} preview={false} />
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountPercAmount ? '₹ ' + currencyFormat(lineDiscountPercAmount) : '---'}</Typography>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30} align="bottom">
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Row gutter={30} align="bottom">
                                                {
                                                    parameterDetails?.discountRate ? <>
                                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                            <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Type</Typography>
                                                            <FormControl
                                                                className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                                                variant={'standard'}
                                                                fullWidth>
                                                                <RadioGroup
                                                                    row
                                                                    value={lineDiscountType}
                                                                    onChange={(e) => {
                                                                        setLineDiscountType(e.target.value);
                                                                        setLineDiscountRate('');
                                                                        setLineDiscountAmount('');
                                                                    }}>
                                                                    <FormControlLabel value="perUnit" control={<Radio
                                                                        checkedIcon={<UnSelectedIcon />}
                                                                        icon={<SelectedIcon />}
                                                                    />} label="Per Unit" />
                                                                    <FormControlLabel value="fixed" control={<Radio
                                                                        checkedIcon={<UnSelectedIcon />}
                                                                        icon={<SelectedIcon />}
                                                                    />} label="Fixed" />
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </Col>
                                                        {
                                                            lineDiscountType === 'perUnit' ? <>
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <TextField autoComplete='one-time-code'
                                                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                                                        label='Discount Rate / Unit'
                                                                        variant={'standard'}
                                                                        title={'Enter Discount Rate / Unit'}
                                                                        type={'number'}
                                                                        id={idNamingConversion('Discount Rate / Unit', 'purchaseBillLine', 'TextField')}
                                                                        value={lineDiscountRate}
                                                                        fullWidth
                                                                        InputProps={{
                                                                            classes: {
                                                                                input: classes.textFieldColor,
                                                                            }
                                                                        }}
                                                                        inputProps={{
                                                                            step: "any"
                                                                        }}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        InputLabelProps={{
                                                                            className: classes.textFieldLableColorCustom,
                                                                        }}
                                                                        onChange={(e) => handleLineDiscountRateChange(e.target.value)}
                                                                    />
                                                                </Col>
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                                        <span>Discount Amount</span></Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountAmount ? '₹ ' + currencyFormat(lineDiscountAmount) : '---'}</Typography>
                                                                </Col>
                                                            </> : <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <TextField autoComplete='one-time-code'
                                                                    className={clsx(classes.margin20t, classes.removeUnderline)}
                                                                    label='Discount Amount'
                                                                    variant={'standard'}
                                                                    title={'Enter discount in Amount'}
                                                                    type={'number'}
                                                                    id={idNamingConversion('Discount Amount', 'purchaseBillLine', 'TextField')}

                                                                    value={lineDiscountAmount}
                                                                    fullWidth
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: classes.textFieldColor,
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        step: "any"
                                                                    }}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    InputLabelProps={{
                                                                        className: classes.textFieldLableColorCustom,
                                                                    }}
                                                                    onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineDiscountAmount((e.target.value = 0)) : setLineDiscountAmount(e.target.value) : setLineDiscountAmount(e.target.value)}
                                                                />
                                                            </Col>
                                                        }
                                                    </> : <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <TextField autoComplete='one-time-code'
                                                            className={clsx(classes.margin20t, classes.removeUnderline)}
                                                            label='Discount Amount'
                                                            variant={'standard'}
                                                            title={'Enter discount in Amount'}
                                                            type={'number'}
                                                            id={idNamingConversion('Discount Amount', 'purchaseBillLine', 'TextField')}
                                                            value={lineDiscountAmount}
                                                            fullWidth
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,
                                                                }
                                                            }}
                                                            inputProps={{
                                                                step: "any"
                                                            }}
                                                            onWheel={(e) => e.target.blur()}
                                                            InputLabelProps={{
                                                                className: classes.textFieldLableColorCustom,
                                                            }}
                                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineDiscountAmount((e.target.value = 0)) : setLineDiscountAmount(e.target.value) : setLineDiscountAmount(e.target.value)}
                                                        />
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                <span>Total Discount Amount</span>
                                                <Tooltip
                                                    classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                    title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                    <IconButton>
                                                        <Image src={infoMarkIcon} preview={false} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountCalcAmount ? '₹ ' + currencyFormat(lineDiscountCalcAmount) : '---'}</Typography>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30}>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Row gutter={30}>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Location</Typography>
                                                </Col>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <AutoCompleteComponent
                                                        name={NAME_LOCATION}
                                                        heads={LOCATION_HEADS}
                                                        details={locationDetails}
                                                        id={idNamingConversion('Location', 'purchaseBillLine', 'DropDown')}
                                                        parentValue={customObject(locationDetails, lineLocationId)}
                                                        onChange={stableLocationChange}
                                                        position={"bottom"}
                                                        searchType={stableLocationApi}
                                                        customClasses={classes.margin10t}
                                                        reset={false}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>

                                    </Row>
                                </Col>
                                {
                                    lineExcisesApplicable && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Row gutter={30}>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Total</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise</Typography>
                                                <FormControl
                                                    className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                                    variant={'standard'}
                                                    fullWidth>
                                                    <RadioGroup
                                                        row
                                                        value={lineExcisesType}
                                                        onChange={(e) => {
                                                            setLineExcisesType(e.target.value);
                                                        }}>
                                                        <FormControlLabel value="perUnit" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Per Unit" />
                                                        <FormControlLabel value="fixed" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Fixed" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Total</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineExcisesTotal || 0}</Typography>
                                            </Col>
                                            {
                                                lineExcisesType === 'perUnit' ? <> <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    <TextField autoComplete='one-time-code'
                                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                                        label='Excise Rate / Unit'
                                                        variant={'standard'}
                                                        title={'Enter Excise Rate / Unit'}
                                                        type={'number'}
                                                        id={idNamingConversion('Excise Rate / Unit', 'purchaseBillLine', 'TextField')}
                                                        // error={errorLineExcisesAmount ? true : false}
                                                        // helperText={errorLineExcisesAmount ? errorLineExcisesAmount : ''}
                                                        value={lineExcisesRate}
                                                        fullWidth
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        inputProps={{
                                                            step: "any"
                                                        }}
                                                        onWheel={(e) => e.target.blur()}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColorCustom,
                                                        }}
                                                        onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineExcisesRate((e.target.value = 0)) : setLineExcisesRate(e.target.value) : setLineExcisesRate(e.target.value)}
                                                    />
                                                </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineExcisesAmount || 0}</Typography>
                                                    </Col></> : <><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <TextField autoComplete='one-time-code'
                                                            className={clsx(classes.margin20t, classes.removeUnderline)}
                                                            label='Excise Amount'
                                                            variant={'standard'}
                                                            title={'Enter Excise Amount'}
                                                            type={'number'}
                                                            id={idNamingConversion('Excise Amount', 'purchaseBillLine', 'TextField')}
                                                            // error={errorLineExcisesAmount ? true : false}
                                                            // helperText={errorLineExcisesAmount ? errorLineExcisesAmount : ''}
                                                            value={lineExcisesAmount}
                                                            fullWidth
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,
                                                                }
                                                            }}
                                                            inputProps={{
                                                                step: "any"
                                                            }}
                                                            onWheel={(e) => e.target.blur()}
                                                            InputLabelProps={{
                                                                className: classes.textFieldLableColorCustom,
                                                            }}
                                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineExcisesAmount((e.target.value = 0)) : setLineExcisesAmount(e.target.value) : setLineExcisesAmount(e.target.value)}
                                                        />
                                                    </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col></>
                                            }
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise</Typography>
                                                <FormControl
                                                    className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                                    variant={'standard'}
                                                    fullWidth>
                                                    <RadioGroup
                                                        row
                                                        value={lineSplExcisesType}
                                                        onChange={(e) => {
                                                            setLineSplExcisesType(e.target.value);
                                                        }}>
                                                        <FormControlLabel value="perUnit" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Per Unit" />
                                                        <FormControlLabel value="fixed" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Fixed" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col>
                                            {
                                                lineSplExcisesType === 'perUnit' ? <> <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    <TextField autoComplete='one-time-code'
                                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                                        label='SPL Excise Rate / Unit'
                                                        variant={'standard'}
                                                        title={'Enter SPL Excise Rate / Unit'}
                                                        type={'number'}
                                                        id={idNamingConversion('Excise SPL Rate / Unit', 'purchaseBillLine', 'TextField')}
                                                        // error={errorLineSplExcisesAmount ? true : false}
                                                        // helperText={errorLineSplExcisesAmount ? errorLineSplExcisesAmount : ''}
                                                        value={lineSplExcisesRate}
                                                        fullWidth
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        inputProps={{
                                                            step: "any"
                                                        }}
                                                        onWheel={(e) => e.target.blur()}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColorCustom,
                                                        }}
                                                        onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineSplExcisesRate((e.target.value = 0)) : setLineSplExcisesRate(e.target.value) : setLineSplExcisesRate(e.target.value)}
                                                    />
                                                </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSplExcisesAmount || 0}</Typography>
                                                    </Col></> : <><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <TextField autoComplete='one-time-code'
                                                            className={clsx(classes.margin20t, classes.removeUnderline)}
                                                            label='SPL Excise Amount'
                                                            variant={'standard'}
                                                            title={'Enter SPL Excise Amount'}
                                                            type={'number'}
                                                            id={idNamingConversion('SPL Excise Amount', 'purchaseBillLine', 'TextField')}
                                                            value={lineSplExcisesAmount}
                                                            // error={errorLineSplExcisesAmount ? true : false}
                                                            // helperText={errorLineSplExcisesAmount ? errorLineSplExcisesAmount : ''}
                                                            fullWidth
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,
                                                                }
                                                            }}
                                                            inputProps={{
                                                                step: "any"
                                                            }}
                                                            onWheel={(e) => e.target.blur()}
                                                            InputLabelProps={{
                                                                className: classes.textFieldLableColorCustom,
                                                            }}
                                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineSplExcisesAmount((e.target.value = 0)) : setLineSplExcisesAmount(e.target.value) : setLineSplExcisesAmount(e.target.value)}
                                                        />
                                                    </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col></>
                                            }
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <TextField autoComplete='one-time-code'
                                                    className={clsx(classes.margin20t, classes.removeUnderline)}
                                                    label='Additional Excise Amount'
                                                    variant={'standard'}
                                                    title={'Enter Additional Excise Amount'}
                                                    type={'number'}
                                                    id={idNamingConversion('Additional Excise Amount', 'purchaseBillLine', 'TextField')}
                                                    value={lineAddExcisesAmount}
                                                    fullWidth
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    inputProps={{
                                                        step: "any"
                                                    }}
                                                    onWheel={(e) => e.target.blur()}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineAddExcisesAmount((e.target.value = 0)) : setLineAddExcisesAmount(e.target.value) : setLineAddExcisesAmount(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Cost Price</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{currencyFormat(lineTotalCostPrice || 0)}</Typography>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30}>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>GST Details </Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <FormControlLabel
                                                classes={{
                                                    label: classes.fonSize13,
                                                }}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => handleLineIncludeGst(!lineIncludeGst)}
                                                    checked={lineIncludeGst}
                                                />}
                                                id={idNamingConversion('Tax Invoice', 'purchaseBillLine', 'Radio')}
                                                label="Tax Invoice"
                                                labelPlacement="top"
                                                disabled={!includeGst}
                                                className={clsx(classes.margin20t, classes.marginLeft0, classes.flexStart)}
                                            />
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={NAME_PRODUCT_GST}
                                                heads={PRODUCT_GST_HEADS}
                                                details={productGstdetails}
                                                parentValue={customObject(productGstdetails, lineProductGstId)}
                                                onChange={stableLineProductGstChange}
                                                parentError={errorLineProductGst}
                                                position={"top"}
                                                id={idNamingConversion('Product GST Code', 'purchaseBillLine', 'DropDown')}
                                                topPosition={true}
                                                disabled={!lineIncludeGst}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>CGST</Typography>
                                            <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineCgst ? lineCgst + '%' : '---'} - {lineCgst && lineCgstAmount ? '₹ ' + currencyFormat(lineCgstAmount) : '---'}</Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={NAME_HSN}
                                                heads={HSN_HEADS}
                                                details={hsnDetails}
                                                parentValue={customObject(hsnDetails, lineHsnId)}
                                                onChange={stableLineHsnChange}
                                                position={"top"}
                                                id={idNamingConversion('HSN Code', 'purchaseBillLine', 'DropDown')}
                                                parentError={errorLineHsn}
                                                searchType={stableHsnApi}
                                                topPosition={true}
                                                disabled={!lineIncludeGst}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SGST / UTGST</Typography>
                                            <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSgst ? lineSgst + '%' : '---'} - {lineSgst && lineSgstAmount ? '₹ ' + currencyFormat(lineSgstAmount) : '---'}</Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                <span>GST Amount </span>
                                                <Tooltip
                                                    classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                    title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                    <IconButton>
                                                        <Image src={infoMarkIcon} preview={false} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Typography>
                                            <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineGstAmount ? '₹ ' + currencyFormat(lineGstAmount) : '---'}</Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>IGST</Typography>
                                            <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineIgst ? lineIgst + '%' : '---'} - {lineIgst && lineIgstAmount ? '₹ ' + currencyFormat(lineIgstAmount) : '---'}</Typography>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                {
                                    primaryTitle === 'Add' && <Button
                                        tabIndex={-1}
                                        key="add"
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.AddMoreBtn, { [classes.loading]: stockLoading })}
                                        onClick={(e) => handleAddMore(e)}
                                        id={idNamingConversion('Add More', 'purchaseBillLine', 'Button')}>
                                        Add More
                                    </Button>
                                }
                                <Button
                                    tabIndex={-1}
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: stockLoading })}
                                    id={idNamingConversion('Save', 'purchaseBillLine', 'Button')}>
                                    {primaryTitle === 'Add' ? 'Save' : 'Update'}
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={viewVisible}
                variant={'temporary'}
                handleClose={() => handleViewClose()}
                width={'690px'}
                title={'View Purchase Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <Box className={clsx(classes.customForm, classes.removeUnderline)}>
                        <div className={classes.customFormFlex}>
                            <Row gutter={30}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.margin10t, classes.typographyHeader, classes.bold)}>Line {lineNumber} Details</Typography>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product {lineProduct ? (
                                        myProductdetails && myProductdetails.length > 0 &&
                                        myProductdetails.filter(mP => mP.id === lineProduct).map(filteredProducts => (
                                            <React.Fragment key={filteredProducts?.id}>
                                                {'- ' + filteredProducts?.productId}
                                            </React.Fragment>
                                        )))
                                        : '---'}</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {lineProduct ? (
                                            myProductdetails && myProductdetails.length > 0 &&
                                            myProductdetails.filter(mP => mP.id === lineProduct).map(filteredProducts => (
                                                <React.Fragment key={filteredProducts?.id}>
                                                    {filteredProducts?.productName}
                                                </React.Fragment>
                                            )))
                                            : '---'}
                                    </Typography>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}><span className={classes.descEllipsis}>{lineDescription ? lineDescription : '---'}</span></Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Quantity</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineQuantity ? lineQuantity : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Unit</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{
                                        unitMesurementdetails && unitMesurementdetails.length > 0 && unitMesurementdetails.filter(unitMesurementdetail => unitMesurementdetail.id === lineUnitId).map(filteredUnit => (
                                            <React.Fragment key={filteredUnit.id}>
                                                {filteredUnit.name}
                                            </React.Fragment>
                                        ))
                                    }</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Unit Price</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{'₹ ' + currencyFormat(linePrice || 0)}</Typography>

                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Row>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>MRP</Typography>
                                            <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}><span className={classes.descEllipsis}>{lineMrp ? '₹ ' + currencyFormat(lineMrp) : '---'}</span></Typography>
                                        </Col>
                                        {parameterDetails?.purchaseValue &&
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} style={{ textAlign: "right" }}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Purchase Value</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSalesValue ? '₹ ' + currencyFormat(lineSalesValue || 0) : '---'}</Typography>
                                            </Col>
                                        }
                                    </Row>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row align="bottom">
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Line Amount</Typography>
                                            <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{'₹ ' + currencyFormat(lineAmount || 0)}</Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            {
                                                lineBatchActivation && parameterDetails?.inventoryTransaction ?
                                                    <NavLink
                                                        to="#"
                                                        id={idNamingConversion('View Batch', 'purchaseBill', 'Link')}
                                                        onClick={() => setViewBatch(!viewBatch)}
                                                        className={clsx(classes.customLink, classes.textAlignRight)}>
                                                        <Image
                                                            src={ViewIcon}
                                                            preview={false}
                                                            className={clsx(classes.antImage, classes.padding10Left)}
                                                        /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>View Batch</span>
                                                    </NavLink> : ''
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    viewBatch && parameterDetails?.inventoryTransaction && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Row align="bottom">
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Batch Details</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <TableContainer className={clsx(classes.tablecontain, classes.tablecontainBatch)}>
                                                    <Table stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className={clsx(classes.tablealign)}>Batch ID</TableCell>
                                                                <TableCell className={clsx(classes.tablealign)}>Qty</TableCell>
                                                                {
                                                                    parameterDetails?.purchaseBatchDiscount && <TableCell className={clsx(classes.tablealign, classes.textAlignLeft)}>Disc.Amt</TableCell>
                                                                }
                                                                {
                                                                    parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.tablealign, classes.textAlignLeft)}>Mfg Date</TableCell>}
                                                                {
                                                                    parameterDetails?.batchExpiryDate && <TableCell className={clsx(classes.tablealign, classes.textAlignLeft)}>Expiry Date</TableCell>}
                                                                {
                                                                    parameterDetails?.batchBestBeforeDate && <TableCell className={clsx(classes.tablealign, classes.textAlignLeft)}>Use By | Best Before</TableCell>}
                                                            </TableRow>
                                                        </TableHead>
                                                        {
                                                            batch?.length > 0 ? batch.map((data, i) => (
                                                                <TableRow id={'tableRow_' + i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative)}>
                                                                    <TableCell className={clsx(classes.storeSalesLineCell)}>{data?.batchNumber}</TableCell>
                                                                    {
                                                                        debitNote ? <TableCell className={clsx(classes.storeSalesLineCell)}>{data?.debitQuantity}</TableCell> : <TableCell className={clsx(classes.storeSalesLineCell)}>{data?.purchaseQuantity}</TableCell>
                                                                    }
                                                                    {
                                                                        parameterDetails?.purchaseBatchDiscount && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.discountAmount || '---'}</TableCell>
                                                                    }
                                                                    {
                                                                        parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.manufacturingDate ? moment(data?.manufacturingDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                    {
                                                                        parameterDetails?.batchExpiryDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.expiryDate ? moment(data?.expiryDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                    {
                                                                        parameterDetails?.batchBestBeforeDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.useByDate ? moment(data?.useByDate).format('DD-MMM-YYYY') : '---'}</TableCell>}

                                                                </TableRow>
                                                            )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                <TableCell className={classes.textAlignCenter} colSpan={5}>
                                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Please add batch'}</p>
                                                                </TableCell>
                                                            </TableRow>
                                                        }
                                                    </Table>
                                                </TableContainer>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Discount Details</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount %</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountPercentage ? lineDiscountPercentage : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                        <span>Calculated discount amount</span>
                                        <Tooltip
                                            classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                            title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                            <IconButton>
                                                <Image src={infoMarkIcon} preview={false} />
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountPercAmount ? '₹ ' + currencyFormat(lineDiscountPercAmount) : '---'}</Typography>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30} align="bottom">
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Row>
                                                {
                                                    parameterDetails?.discountRate ? <>
                                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Type</Typography>
                                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountType || '---'}</Typography>
                                                        </Col>
                                                        {
                                                            lineDiscountType === 'perUnit' ? <>
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Rate / Unit </Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountRate ? '₹ ' + currencyFormat(lineDiscountRate) : '---'}</Typography>
                                                                </Col>
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Amount </Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountAmount ? '₹ ' + currencyFormat(lineDiscountAmount) : '---'}</Typography>
                                                                </Col>
                                                            </> : <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Amount </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountAmount ? '₹ ' + currencyFormat(lineDiscountAmount) : '---'}</Typography>
                                                            </Col>
                                                        }
                                                    </> : <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Amount </Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountAmount ? '₹ ' + currencyFormat(lineDiscountAmount) : '---'}</Typography>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                <span>Total Discount Amount</span>
                                                <Tooltip
                                                    classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                    title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                    <IconButton><Image src={infoMarkIcon} preview={false} /></IconButton>
                                                </Tooltip>
                                            </Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountCalcAmount ? '₹ ' + currencyFormat(lineDiscountCalcAmount) : '---'}</Typography>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30}>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Row gutter={30}>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Location</Typography>
                                                </Col>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    {
                                                        lineLocationId ? locationDetails && locationDetails.length > 0 && locationDetails.filter(locationDetail => locationDetail.id === lineLocationId).map(filteredLocation => (
                                                            <React.Fragment key={filteredLocation.id}>
                                                                {filteredLocation.name}
                                                            </React.Fragment>
                                                        )) : '---'
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>

                                    </Row>
                                </Col>
                                {
                                    lineExcisesApplicable && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Row gutter={30}>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Total</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineExcisesType || '---'}</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Total</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineExcisesTotal || 0)}</Typography>
                                            </Col>
                                            {
                                                lineExcisesType === 'perUnit' ? <> <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Rate / Unit</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineExcisesRate || 0)}</Typography>
                                                </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineExcisesAmount || 0)}</Typography>
                                                    </Col></> : <><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineExcisesAmount || 0)}</Typography>
                                                    </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col></>
                                            }
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSplExcisesType || '---'}</Typography>
                                            </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col>
                                            {
                                                lineSplExcisesType === 'perUnit' ? <> <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise Rate / Unit</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineSplExcisesRate || 0)}</Typography>
                                                </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineSplExcisesAmount || 0)}</Typography>
                                                    </Col></> : <><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineSplExcisesAmount || 0)}</Typography>
                                                    </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col></>
                                            }
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Additional Excise Amount</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineAddExcisesAmount || 0)}</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Cost Price</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineTotalCostPrice || 0)}</Typography>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>GST Details </Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin35t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax Invoice</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineIncludeGst ? 'Yes' : 'No'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Gst Code</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{
                                        lineProductGstId ? productGstdetails && productGstdetails.length > 0 && productGstdetails.filter(productGstdetail => productGstdetail.id === lineProductGstId).map(filteredGst => (
                                            <React.Fragment key={filteredGst.id}>
                                                {filteredGst.code}
                                            </React.Fragment>
                                        )) : '---'
                                    }</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>CGST</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineCgst ? lineCgst + '%' : '---'} - {lineCgstAmount || notificationLineCgstAmount ? '₹ ' + currencyFormat(readDetails?.isViaNotification ? notificationLineCgstAmount : lineCgstAmount) : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>HSN Code</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{
                                        lineHsnId ? hsnDetails && hsnDetails.length > 0 && hsnDetails.filter(hsnDetail => hsnDetail.id === lineHsnId).map(filteredHsn => (
                                            <React.Fragment key={filteredHsn.id}>
                                                {filteredHsn.hsnCode}
                                            </React.Fragment>
                                        )) : '---'
                                    }</Typography>

                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SGST / UTGST</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSgst ? lineSgst + '%' : '---'} - {lineSgstAmount || notificationLineSgstAmount ? '₹ ' + currencyFormat(readDetails?.isViaNotification ? notificationLineSgstAmount : lineSgstAmount) : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                        <span>GST Amount </span>
                                        <Tooltip
                                            classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                            title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                            <IconButton>
                                                <Image src={infoMarkIcon} preview={false} />
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineGstAmount ? '₹ ' + currencyFormat(readDetails?.isViaNotification ? notificationLineGstAmount : lineGstAmount) : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>IGST</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineIgst ? lineIgst + '%' : '---'} - {lineIgstAmount || notificationLineIgstAmount ? '₹ ' + currencyFormat(readDetails?.isViaNotification ? notificationLineIgstAmount : lineIgstAmount) : '---'}</Typography>
                                </Col>
                            </Row>
                        </div>
                        {
                            !readDetails?.isViaNotification && <div className={clsx(classes.btnParent, classes.bold)}>
                                <NavLink to={'#'} onClick={() => onEditButton()} className={clsx(classes.modalBtn, classes.bold, classes.marginRight0)}>Edit</NavLink>
                            </div>
                        }
                    </Box>
                }
            />
            {
                productsVisible && <SupplierProducts
                    classes={classes}
                    clsx={clsx}
                    productGstdetails={productGstdetails}
                    dispatch={dispatch}
                    handleClose={() => setProductsVisible(false)}
                    visible={productsVisible}
                    supplierId={supplierId}
                    includeGst={includeGst}
                    productActions={productActions}
                    businessDetails={businessDetails}
                    supplierDetail={supplierDetail}
                    productPrices={productPrices}
                    priceIncludesTax={priceIncludesTax || false}
                    hsnApi={(s = '', id = '') => hsnApi(s, id)}
                    lineSubmit={(selected) => handleBulkLineSubmit(selected)}
                    lines={lines}
                    viewType={'myProducts'}
                    debitNote={debitNote}
                    locationApi={() => locationApi()}
                    locationDetails={locationDetails}
                    hsnDetails={hsnDetails}
                    unitMesurementdetails={unitMesurementdetails}
                    customObject={(details, id) => customObject(details, id)}
                    emptyValidation={(name, id, type = '') => emptyValidation(name, id, type)}
                    gstCalculation={(business, details, customer) => gstCalculation(business, details, customer)}
                    customNumberValidation={(name, value) => customNumberValidation(name, value)}
                    purchase={true}
                />
            }
            {
                open && (
                    <PurchaseInvoiceModal
                        open={open}
                        title={downloadTitle(preview ? previewData : editData, 'supply-bill')}
                        // title={`Purchase-Bill-${decryptedId}`}
                        handleClose={(o) => handleModalClose(o)}
                        link={preview ? '' : roleManagement !== '' && checkCRUDPermission('Supply Self Bill', 'view', 'Purchase') ? `/purchase/purchase-management/self-bill/${AESEncrypt(decryptedId)}/view` : ''}
                        {...props}
                        businessDetails={businessDetails}
                        format={billFormat}
                        proformaPreview={readDetails?.isViaNotification ? false : preview}
                        details={preview ? previewData : editData}
                        type={'edit'} />
                )
            }
            <Modal
                title={'Delete Confirmation'}
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                className={clsx(classes.commonPopup, classes.deletePopup)}
                // closeIcon={<CloseIcon />}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                        onClick={() => deleteLine()}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => handleCancel()}
                    >
                        No
                    </Button>,
                ]}
            >
                <p>Are you sure you want to <span className={classes.deleteRed}> Delete </span> {lineDescription}</p>
            </Modal>
            <Modal
                title={'Warning message'}
                open={modalVisible}
                onOk={() => setModalVisible(false)}
                onCancel={() => setModalVisible(false)}
                footer={[
                    <Space direction="horizontal" align="center">
                        <NavLink
                            to={`#`} onClick={() => handleWarningYes(!includeGst)}
                            className={clsx(classes.AddMoreBtn, classes.bold, classes.textAlignLeft)}
                        >Yes</NavLink>
                        <NavLink
                            to={`#`} onClick={() => setModalVisible(false)}
                            className={clsx(classes.modalBtn, classes.bold, classes.textAlignLeft)}
                        >No</NavLink>
                    </Space>
                ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)}>
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>
                    {
                        !includeGst ? 'Please note, changing the Tax Invoice to "Yes" should comply to GST law. Are you sure you want to continue to make this change ?'
                            : 'Please note, changing the Tax Invoice to "No" should comply to GST law. Are you sure you want to continue to make this change ?'
                    }
                </Typography>
            </Modal>
            <CustomModal
                visible={confirm}
                yesButton={'Yes'}
                noButton={'No'}
                loading={editLoader}
                title={'Bill Confirmation'}
                onOpen={() => handleCommonSubmit('CONFIRMED')}
                onClose={() => setConfirm(false)}
                text={<p>Are you sure do you want to Confirm the Bill?</p>}
            />
            <CustomModal
                visible={dateChange ? true : false}
                yesButton={'Yes'}
                noButton={'No'}
                title={'Transaction Date'}
                onOpen={() => { setTransactionDate(dateChange); setDateChange(''); }}
                onClose={() => setDateChange('')}
                text={<>
                    <p>It is not recommended to change the Transaction date as it will impact GST reporting and filing of GST Invoices.</p>
                    <p>Any changes you make, please speak to your Supplier about the date change and impact to GST</p>
                </>}
            />
        </React.Fragment>
    )
}
export default PurchaseSelfBillsEdit